// Z80Disass.qunit.ts - QUnit tests for CPCBasic Z80Disass
//

import { Utils } from "../Utils";
import { Z80Disass } from "../Z80Disass";
import { TestHelper, TestsType, AllTestsType, ResultType } from "./TestHelper";

QUnit.dump.maxDepth = 10;

/* eslint-disable quote-props */
const allTests: AllTestsType = {
	normal: {
		"\x00": "NOP",
		"\x01\x01\x02": "LD BC,&0201",
		"\x02": "LD (BC),A",
		"\x03": "INC BC",
		"\x04": "INC B",
		"\x05": "DEC B",
		"\x06\x01": "LD B,&01",
		"\x07": "RLCA",
		"\x08": "EX AF,AF'",
		"\x09": "ADD HL,BC",
		"\x0a": "LD A,(BC)",
		"\x0b": "DEC BC",
		"\x0c": "INC C",
		"\x0d": "DEC C",
		"\x0e\x01": "LD C,&01",
		"\x0f": "RRCA",
		"\x10\x01": "DJNZ &0003",
		"\x11\x01\x02": "LD DE,&0201",
		"\x12": "LD (DE),A",
		"\x13": "INC DE",
		"\x14": "INC D",
		"\x15": "DEC D",
		"\x16\x01": "LD D,&01",
		"\x17": "RLA",
		"\x18\x01": "JR &0003",
		"\x19": "ADD HL,DE",
		"\x1a": "LD A,(DE)",
		"\x1b": "DEC DE",
		"\x1c": "INC E",
		"\x1d": "DEC E",
		"\x1e\x01": "LD E,&01",
		"\x1f": "RRA",
		"\x20\x01": "JR NZ,&0003",
		"\x21\x01\x02": "LD HL,&0201",
		"\x22\x01\x02": "LD (&0201),HL",
		"\x23": "INC HL",
		"\x24": "INC H",
		"\x25": "DEC H",
		"\x26\x01": "LD H,&01",
		"\x27": "DAA",
		"\x28\x01": "JR Z,&0003",
		"\x29": "ADD HL,HL",
		"\x2a\x01\x02": "LD HL,(&0201)",
		"\x2b": "DEC HL",
		"\x2c": "INC L",
		"\x2d": "DEC L",
		"\x2e\x01": "LD L,&01",
		"\x2f": "CPL",
		"\x30\x01": "JR NC,&0003",
		"\x31\x01\x02": "LD SP,&0201",
		"\x32\x01\x02": "LD (&0201),A",
		"\x33": "INC SP",
		"\x34": "INC (HL)",
		"\x35": "DEC (HL)",
		"\x36\x01": "LD (HL),&01",
		"\x37": "SCF",
		"\x38\x01": "JR C,&0003",
		"\x39": "ADD HL,SP",
		"\x3a\x01\x02": "LD A,(&0201)",
		"\x3b": "DEC SP",
		"\x3c": "INC A",
		"\x3d": "DEC A",
		"\x3e\x01": "LD A,&01",
		"\x3f": "CCF",
		"\x40": "LD B,B",
		"\x41": "LD B,C",
		"\x42": "LD B,D",
		"\x43": "LD B,E",
		"\x44": "LD B,H",
		"\x45": "LD B,L",
		"\x46": "LD B,(HL)",
		"\x47": "LD B,A",
		"\x48": "LD C,B",
		"\x49": "LD C,C",
		"\x4a": "LD C,D",
		"\x4b": "LD C,E",
		"\x4c": "LD C,H",
		"\x4d": "LD C,L",
		"\x4e": "LD C,(HL)",
		"\x4f": "LD C,A",
		"\x50": "LD D,B",
		"\x51": "LD D,C",
		"\x52": "LD D,D",
		"\x53": "LD D,E",
		"\x54": "LD D,H",
		"\x55": "LD D,L",
		"\x56": "LD D,(HL)",
		"\x57": "LD D,A",
		"\x58": "LD E,B",
		"\x59": "LD E,C",
		"\x5a": "LD E,D",
		"\x5b": "LD E,E",
		"\x5c": "LD E,H",
		"\x5d": "LD E,L",
		"\x5e": "LD E,(HL)",
		"\x5f": "LD E,A",
		"\x60": "LD H,B",
		"\x61": "LD H,C",
		"\x62": "LD H,D",
		"\x63": "LD H,E",
		"\x64": "LD H,H",
		"\x65": "LD H,L",
		"\x66": "LD H,(HL)",
		"\x67": "LD H,A",
		"\x68": "LD L,B",
		"\x69": "LD L,C",
		"\x6a": "LD L,D",
		"\x6b": "LD L,E",
		"\x6c": "LD L,H",
		"\x6d": "LD L,L",
		"\x6e": "LD L,(HL)",
		"\x6f": "LD L,A",
		"\x70": "LD (HL),B",
		"\x71": "LD (HL),C",
		"\x72": "LD (HL),D",
		"\x73": "LD (HL),E",
		"\x74": "LD (HL),H",
		"\x75": "LD (HL),L",
		"\x76": "HALT",
		"\x77": "LD (HL),A",
		"\x78": "LD A,B",
		"\x79": "LD A,C",
		"\x7a": "LD A,D",
		"\x7b": "LD A,E",
		"\x7c": "LD A,H",
		"\x7d": "LD A,L",
		"\x7e": "LD A,(HL)",
		"\x7f": "LD A,A",
		"\x80": "ADD A,B",
		"\x81": "ADD A,C",
		"\x82": "ADD A,D",
		"\x83": "ADD A,E",
		"\x84": "ADD A,H",
		"\x85": "ADD A,L",
		"\x86": "ADD A,(HL)",
		"\x87": "ADD A,A",
		"\x88": "ADC A,B",
		"\x89": "ADC A,C",
		"\x8a": "ADC A,D",
		"\x8b": "ADC A,E",
		"\x8c": "ADC A,H",
		"\x8d": "ADC A,L",
		"\x8e": "ADC A,(HL)",
		"\x8f": "ADC A,A",
		"\x90": "SUB B",
		"\x91": "SUB C",
		"\x92": "SUB D",
		"\x93": "SUB E",
		"\x94": "SUB H",
		"\x95": "SUB L",
		"\x96": "SUB (HL)",
		"\x97": "SUB A",
		"\x98": "SBC A,B",
		"\x99": "SBC A,C",
		"\x9a": "SBC A,D",
		"\x9b": "SBC A,E",
		"\x9c": "SBC A,H",
		"\x9d": "SBC A,L",
		"\x9e": "SBC A,(HL)",
		"\x9f": "SBC A,A",
		"\xa0": "AND B",
		"\xa1": "AND C",
		"\xa2": "AND D",
		"\xa3": "AND E",
		"\xa4": "AND H",
		"\xa5": "AND L",
		"\xa6": "AND (HL)",
		"\xa7": "AND A",
		"\xa8": "XOR B",
		"\xa9": "XOR C",
		"\xaa": "XOR D",
		"\xab": "XOR E",
		"\xac": "XOR H",
		"\xad": "XOR L",
		"\xae": "XOR (HL)",
		"\xaf": "XOR A",
		"\xb0": "OR B",
		"\xb1": "OR C",
		"\xb2": "OR D",
		"\xb3": "OR E",
		"\xb4": "OR H",
		"\xb5": "OR L",
		"\xb6": "OR (HL)",
		"\xb7": "OR A",
		"\xb8": "CP B",
		"\xb9": "CP C",
		"\xba": "CP D",
		"\xbb": "CP E",
		"\xbc": "CP H",
		"\xbd": "CP L",
		"\xbe": "CP (HL)",
		"\xbf": "CP A",
		"\xc0": "RET NZ",
		"\xc1": "POP BC",
		"\xc2\x01\x02": "JP NZ,&0201",
		"\xc3\x01\x02": "JP &0201",
		"\xc4\x01\x02": "CALL NZ,&0201",
		"\xc5": "PUSH BC",
		"\xc6\x01": "ADD A,&01",
		"\xc7": "RST &00",
		"\xc8": "RET Z",
		"\xc9": "RET",
		"\xca\x01\x02": "JP Z,&0201",
		"\xcb\x01": "RLC C",
		"\xcc\x01\x02": "CALL Z,&0201",
		"\xcd\x01\x02": "CALL &0201",
		"\xce\x01": "ADC A,&01",
		"\xcf": "RST &08",
		"\xd0": "RET NC",
		"\xd1": "POP DE",
		"\xd2\x01\x02": "JP NC,&0201",
		"\xd3\x01": "OUT (&01),A",
		"\xd4\x01\x02": "CALL NC,&0201",
		"\xd5": "PUSH DE",
		"\xd6\x01": "SUB &01",
		"\xd7": "RST &10",
		"\xd8": "RET C",
		"\xd9": "EXX",
		"\xda\x01\x02": "JP C,&0201",
		"\xdb\x01": "IN A,(&01)",
		"\xdc\x01\x02": "CALL C,&0201",
		"\xdd\x01\x00\x00": "LD BC,&0000",
		"\xde\x01": "SBC A,&01",
		"\xdf": "RST &18",
		"\xe0": "RET PO",
		"\xe1": "POP HL",
		"\xe2\x01\x02": "JP PO,&0201",
		"\xe3": "EX (SP),HL",
		"\xe4\x01\x02": "CALL PO,&0201",
		"\xe5": "PUSH HL",
		"\xe6\x01": "AND &01",
		"\xe7": "RST &20",
		"\xe8": "RET PE",
		"\xe9": "JP (HL)",
		"\xea\x01\x02": "JP PE,&0201",
		"\xeb": "EX DE,HL",
		"\xec\x01\x02": "CALL PE,&0201",
		"\xed\x01": "unknown",
		"\xee\x01": "XOR &01",
		"\xef": "RST &28",
		"\xf0": "RET P",
		"\xf1": "POP AF",
		"\xf2\x01\x02": "JP P,&0201",
		"\xf3": "DI",
		"\xf4\x01\x02": "CALL P,&0201",
		"\xf5": "PUSH AF",
		"\xf6\x01": "OR &01",
		"\xf7": "RST &30",
		"\xf8": "RET M",
		"\xf9": "LD SP,HL",
		"\xfa\x01\x02": "JP M,&0201",
		"\xfb": "EI",
		"\xfc\x01\x02": "CALL M,&0201",
		"\xfd\x01\x00\x00": "LD BC,&0000",
		"\xfe\x01": "CP &01",
		"\xff": "RST &38"
	},
	prefixCB: {
		"\xcb\x00": "RLC B",
		"\xcb\x01": "RLC C",
		"\xcb\x02": "RLC D",
		"\xcb\x03": "RLC E",
		"\xcb\x04": "RLC H",
		"\xcb\x05": "RLC L",
		"\xcb\x06": "RLC (HL)",
		"\xcb\x07": "RLC A",
		"\xcb\x08": "RRC B",
		"\xcb\x09": "RRC C",
		"\xcb\x0a": "RRC D",
		"\xcb\x0b": "RRC E",
		"\xcb\x0c": "RRC H",
		"\xcb\x0d": "RRC L",
		"\xcb\x0e": "RRC (HL)",
		"\xcb\x0f": "RRC A",
		"\xcb\x10": "RL B",
		"\xcb\x11": "RL C",
		"\xcb\x12": "RL D",
		"\xcb\x13": "RL E",
		"\xcb\x14": "RL H",
		"\xcb\x15": "RL L",
		"\xcb\x16": "RL (HL)",
		"\xcb\x17": "RL A",
		"\xcb\x18": "RR B",
		"\xcb\x19": "RR C",
		"\xcb\x1a": "RR D",
		"\xcb\x1b": "RR E",
		"\xcb\x1c": "RR H",
		"\xcb\x1d": "RR L",
		"\xcb\x1e": "RR (HL)",
		"\xcb\x1f": "RR A",
		"\xcb\x20": "SLA B",
		"\xcb\x21": "SLA C",
		"\xcb\x22": "SLA D",
		"\xcb\x23": "SLA E",
		"\xcb\x24": "SLA H",
		"\xcb\x25": "SLA L",
		"\xcb\x26": "SLA (HL)",
		"\xcb\x27": "SLA A",
		"\xcb\x28": "SRA B",
		"\xcb\x29": "SRA C",
		"\xcb\x2a": "SRA D",
		"\xcb\x2b": "SRA E",
		"\xcb\x2c": "SRA H",
		"\xcb\x2d": "SRA L",
		"\xcb\x2e": "SRA (HL)",
		"\xcb\x2f": "SRA A",
		"\xcb\x30": "SLS* B",
		"\xcb\x31": "SLS* C",
		"\xcb\x32": "SLS* D",
		"\xcb\x33": "SLS* E",
		"\xcb\x34": "SLS* H",
		"\xcb\x35": "SLS* L",
		"\xcb\x36": "SLS* (HL)",
		"\xcb\x37": "SLS* A",
		"\xcb\x38": "SRL B",
		"\xcb\x39": "SRL C",
		"\xcb\x3a": "SRL D",
		"\xcb\x3b": "SRL E",
		"\xcb\x3c": "SRL H",
		"\xcb\x3d": "SRL L",
		"\xcb\x3e": "SRL (HL)",
		"\xcb\x3f": "SRL A",
		"\xcb\x40": "BIT 0,B",
		"\xcb\x41": "BIT 0,C",
		"\xcb\x42": "BIT 0,D",
		"\xcb\x43": "BIT 0,E",
		"\xcb\x44": "BIT 0,H",
		"\xcb\x45": "BIT 0,L",
		"\xcb\x46": "BIT 0,(HL)",
		"\xcb\x47": "BIT 0,A",
		"\xcb\x48": "BIT 1,B",
		"\xcb\x49": "BIT 1,C",
		"\xcb\x4a": "BIT 1,D",
		"\xcb\x4b": "BIT 1,E",
		"\xcb\x4c": "BIT 1,H",
		"\xcb\x4d": "BIT 1,L",
		"\xcb\x4e": "BIT 1,(HL)",
		"\xcb\x4f": "BIT 1,A",
		"\xcb\x50": "BIT 2,B",
		"\xcb\x51": "BIT 2,C",
		"\xcb\x52": "BIT 2,D",
		"\xcb\x53": "BIT 2,E",
		"\xcb\x54": "BIT 2,H",
		"\xcb\x55": "BIT 2,L",
		"\xcb\x56": "BIT 2,(HL)",
		"\xcb\x57": "BIT 2,A",
		"\xcb\x58": "BIT 3,B",
		"\xcb\x59": "BIT 3,C",
		"\xcb\x5a": "BIT 3,D",
		"\xcb\x5b": "BIT 3,E",
		"\xcb\x5c": "BIT 3,H",
		"\xcb\x5d": "BIT 3,L",
		"\xcb\x5e": "BIT 3,(HL)",
		"\xcb\x5f": "BIT 3,A",
		"\xcb\x60": "BIT 4,B",
		"\xcb\x61": "BIT 4,C",
		"\xcb\x62": "BIT 4,D",
		"\xcb\x63": "BIT 4,E",
		"\xcb\x64": "BIT 4,H",
		"\xcb\x65": "BIT 4,L",
		"\xcb\x66": "BIT 4,(HL)",
		"\xcb\x67": "BIT 4,A",
		"\xcb\x68": "BIT 5,B",
		"\xcb\x69": "BIT 5,C",
		"\xcb\x6a": "BIT 5,D",
		"\xcb\x6b": "BIT 5,E",
		"\xcb\x6c": "BIT 5,H",
		"\xcb\x6d": "BIT 5,L",
		"\xcb\x6e": "BIT 5,(HL)",
		"\xcb\x6f": "BIT 5,A",
		"\xcb\x70": "BIT 6,B",
		"\xcb\x71": "BIT 6,C",
		"\xcb\x72": "BIT 6,D",
		"\xcb\x73": "BIT 6,E",
		"\xcb\x74": "BIT 6,H",
		"\xcb\x75": "BIT 6,L",
		"\xcb\x76": "BIT 6,(HL)",
		"\xcb\x77": "BIT 6,A",
		"\xcb\x78": "BIT 7,B",
		"\xcb\x79": "BIT 7,C",
		"\xcb\x7a": "BIT 7,D",
		"\xcb\x7b": "BIT 7,E",
		"\xcb\x7c": "BIT 7,H",
		"\xcb\x7d": "BIT 7,L",
		"\xcb\x7e": "BIT 7,(HL)",
		"\xcb\x7f": "BIT 7,A",
		"\xcb\x80": "RES 0,B",
		"\xcb\x81": "RES 0,C",
		"\xcb\x82": "RES 0,D",
		"\xcb\x83": "RES 0,E",
		"\xcb\x84": "RES 0,H",
		"\xcb\x85": "RES 0,L",
		"\xcb\x86": "RES 0,(HL)",
		"\xcb\x87": "RES 0,A",
		"\xcb\x88": "RES 1,B",
		"\xcb\x89": "RES 1,C",
		"\xcb\x8a": "RES 1,D",
		"\xcb\x8b": "RES 1,E",
		"\xcb\x8c": "RES 1,H",
		"\xcb\x8d": "RES 1,L",
		"\xcb\x8e": "RES 1,(HL)",
		"\xcb\x8f": "RES 1,A",
		"\xcb\x90": "RES 2,B",
		"\xcb\x91": "RES 2,C",
		"\xcb\x92": "RES 2,D",
		"\xcb\x93": "RES 2,E",
		"\xcb\x94": "RES 2,H",
		"\xcb\x95": "RES 2,L",
		"\xcb\x96": "RES 2,(HL)",
		"\xcb\x97": "RES 2,A",
		"\xcb\x98": "RES 3,B",
		"\xcb\x99": "RES 3,C",
		"\xcb\x9a": "RES 3,D",
		"\xcb\x9b": "RES 3,E",
		"\xcb\x9c": "RES 3,H",
		"\xcb\x9d": "RES 3,L",
		"\xcb\x9e": "RES 3,(HL)",
		"\xcb\x9f": "RES 3,A",
		"\xcb\xa0": "RES 4,B",
		"\xcb\xa1": "RES 4,C",
		"\xcb\xa2": "RES 4,D",
		"\xcb\xa3": "RES 4,E",
		"\xcb\xa4": "RES 4,H",
		"\xcb\xa5": "RES 4,L",
		"\xcb\xa6": "RES 4,(HL)",
		"\xcb\xa7": "RES 4,A",
		"\xcb\xa8": "RES 5,B",
		"\xcb\xa9": "RES 5,C",
		"\xcb\xaa": "RES 5,D",
		"\xcb\xab": "RES 5,E",
		"\xcb\xac": "RES 5,H",
		"\xcb\xad": "RES 5,L",
		"\xcb\xae": "RES 5,(HL)",
		"\xcb\xaf": "RES 5,A",
		"\xcb\xb0": "RES 6,B",
		"\xcb\xb1": "RES 6,C",
		"\xcb\xb2": "RES 6,D",
		"\xcb\xb3": "RES 6,E",
		"\xcb\xb4": "RES 6,H",
		"\xcb\xb5": "RES 6,L",
		"\xcb\xb6": "RES 6,(HL)",
		"\xcb\xb7": "RES 6,A",
		"\xcb\xb8": "RES 7,B",
		"\xcb\xb9": "RES 7,C",
		"\xcb\xba": "RES 7,D",
		"\xcb\xbb": "RES 7,E",
		"\xcb\xbc": "RES 7,H",
		"\xcb\xbd": "RES 7,L",
		"\xcb\xbe": "RES 7,(HL)",
		"\xcb\xbf": "RES 7,A",
		"\xcb\xc0": "SET 0,B",
		"\xcb\xc1": "SET 0,C",
		"\xcb\xc2": "SET 0,D",
		"\xcb\xc3": "SET 0,E",
		"\xcb\xc4": "SET 0,H",
		"\xcb\xc5": "SET 0,L",
		"\xcb\xc6": "SET 0,(HL)",
		"\xcb\xc7": "SET 0,A",
		"\xcb\xc8": "SET 1,B",
		"\xcb\xc9": "SET 1,C",
		"\xcb\xca": "SET 1,D",
		"\xcb\xcb": "SET 1,E",
		"\xcb\xcc": "SET 1,H",
		"\xcb\xcd": "SET 1,L",
		"\xcb\xce": "SET 1,(HL)",
		"\xcb\xcf": "SET 1,A",
		"\xcb\xd0": "SET 2,B",
		"\xcb\xd1": "SET 2,C",
		"\xcb\xd2": "SET 2,D",
		"\xcb\xd3": "SET 2,E",
		"\xcb\xd4": "SET 2,H",
		"\xcb\xd5": "SET 2,L",
		"\xcb\xd6": "SET 2,(HL)",
		"\xcb\xd7": "SET 2,A",
		"\xcb\xd8": "SET 3,B",
		"\xcb\xd9": "SET 3,C",
		"\xcb\xda": "SET 3,D",
		"\xcb\xdb": "SET 3,E",
		"\xcb\xdc": "SET 3,H",
		"\xcb\xdd": "SET 3,L",
		"\xcb\xde": "SET 3,(HL)",
		"\xcb\xdf": "SET 3,A",
		"\xcb\xe0": "SET 4,B",
		"\xcb\xe1": "SET 4,C",
		"\xcb\xe2": "SET 4,D",
		"\xcb\xe3": "SET 4,E",
		"\xcb\xe4": "SET 4,H",
		"\xcb\xe5": "SET 4,L",
		"\xcb\xe6": "SET 4,(HL)",
		"\xcb\xe7": "SET 4,A",
		"\xcb\xe8": "SET 5,B",
		"\xcb\xe9": "SET 5,C",
		"\xcb\xea": "SET 5,D",
		"\xcb\xeb": "SET 5,E",
		"\xcb\xec": "SET 5,H",
		"\xcb\xed": "SET 5,L",
		"\xcb\xee": "SET 5,(HL)",
		"\xcb\xef": "SET 5,A",
		"\xcb\xf0": "SET 6,B",
		"\xcb\xf1": "SET 6,C",
		"\xcb\xf2": "SET 6,D",
		"\xcb\xf3": "SET 6,E",
		"\xcb\xf4": "SET 6,H",
		"\xcb\xf5": "SET 6,L",
		"\xcb\xf6": "SET 6,(HL)",
		"\xcb\xf7": "SET 6,A",
		"\xcb\xf8": "SET 7,B",
		"\xcb\xf9": "SET 7,C",
		"\xcb\xfa": "SET 7,D",
		"\xcb\xfb": "SET 7,E",
		"\xcb\xfc": "SET 7,H",
		"\xcb\xfd": "SET 7,L",
		"\xcb\xfe": "SET 7,(HL)",
		"\xcb\xff": "SET 7,A"
	},
	prefixDD: {
		"\xdd\x00": "NOP",
		"\xdd\x01\x01\x02": "LD BC,&0201",
		"\xdd\x02": "LD (BC),A",
		"\xdd\x03": "INC BC",
		"\xdd\x04": "INC B",
		"\xdd\x05": "DEC B",
		"\xdd\x06\x01": "LD B,&01",
		"\xdd\x07": "RLCA",
		"\xdd\x08": "EX AF,AF'",
		"\xdd\x09": "ADD IX,BC",
		"\xdd\x0a": "LD A,(BC)",
		"\xdd\x0b": "DEC BC",
		"\xdd\x0c": "INC C",
		"\xdd\x0d": "DEC C",
		"\xdd\x0e\x01": "LD C,&01",
		"\xdd\x0f": "RRCA",
		"\xdd\x10\x01": "DJNZ &0004",
		"\xdd\x11\x01\x02": "LD DE,&0201",
		"\xdd\x12": "LD (DE),A",
		"\xdd\x13": "INC DE",
		"\xdd\x14": "INC D",
		"\xdd\x15": "DEC D",
		"\xdd\x16\x01": "LD D,&01",
		"\xdd\x17": "RLA",
		"\xdd\x18\x01": "JR &0004",
		"\xdd\x19": "ADD IX,DE",
		"\xdd\x1a": "LD A,(DE)",
		"\xdd\x1b": "DEC DE",
		"\xdd\x1c": "INC E",
		"\xdd\x1d": "DEC E",
		"\xdd\x1e\x01": "LD E,&01",
		"\xdd\x1f": "RRA",
		"\xdd\x20\x01": "JR NZ,&0004",
		"\xdd\x21\x01\x02": "LD IX,&0201",
		"\xdd\x22\x01\x02": "LD (&0201),IX",
		"\xdd\x23": "INC IX",
		"\xdd\x24": "INC HX",
		"\xdd\x25": "DEC HX",
		"\xdd\x26\x01": "LD HX,&01",
		"\xdd\x27": "DAA",
		"\xdd\x28\x01": "JR Z,&0004",
		"\xdd\x29": "ADD IX,IX",
		"\xdd\x2a\x01\x02": "LD IX,(&0201)",
		"\xdd\x2b": "DEC IX",
		"\xdd\x2c": "INC LX",
		"\xdd\x2d": "DEC LX",
		"\xdd\x2e\x01": "LD LX,&01",
		"\xdd\x2f": "CPL",
		"\xdd\x30\x01": "JR NC,&0004",
		"\xdd\x31\x01\x02": "LD SP,&0201",
		"\xdd\x32\x01\x02": "LD (&0201),A",
		"\xdd\x33": "INC SP",
		"\xdd\x34\x01": "INC (IX+&01)",
		"\xdd\x35\x01": "DEC (IX+&01)",
		"\xdd\x36\x01\x02": "LD (IX+&01),&02",
		"\xdd\x37": "SCF",
		"\xdd\x38\x01": "JR C,&0004",
		"\xdd\x39": "ADD IX,SP",
		"\xdd\x3a\x01\x02": "LD A,(&0201)",
		"\xdd\x3b": "DEC SP",
		"\xdd\x3c": "INC A",
		"\xdd\x3d": "DEC A",
		"\xdd\x3e\x01": "LD A,&01",
		"\xdd\x3f": "CCF",
		"\xdd\x40": "LD B,B",
		"\xdd\x41": "LD B,C",
		"\xdd\x42": "LD B,D",
		"\xdd\x43": "LD B,E",
		"\xdd\x44": "LD B,HX",
		"\xdd\x45": "LD B,LX",
		"\xdd\x46\x01": "LD B,(IX+&01)",
		"\xdd\x47": "LD B,A",
		"\xdd\x48": "LD C,B",
		"\xdd\x49": "LD C,C",
		"\xdd\x4a": "LD C,D",
		"\xdd\x4b": "LD C,E",
		"\xdd\x4c": "LD C,HX",
		"\xdd\x4d": "LD C,LX",
		"\xdd\x4e\x01": "LD C,(IX+&01)",
		"\xdd\x4f": "LD C,A",
		"\xdd\x50": "LD D,B",
		"\xdd\x51": "LD D,C",
		"\xdd\x52": "LD D,D",
		"\xdd\x53": "LD D,E",
		"\xdd\x54": "LD D,HX",
		"\xdd\x55": "LD D,LX",
		"\xdd\x56\x01": "LD D,(IX+&01)",
		"\xdd\x57": "LD D,A",
		"\xdd\x58": "LD E,B",
		"\xdd\x59": "LD E,C",
		"\xdd\x5a": "LD E,D",
		"\xdd\x5b": "LD E,E",
		"\xdd\x5c": "LD E,HX",
		"\xdd\x5d": "LD E,LX",
		"\xdd\x5e\x01": "LD E,(IX+&01)",
		"\xdd\x5f": "LD E,A",
		"\xdd\x60": "LD HX,B",
		"\xdd\x61": "LD HX,C",
		"\xdd\x62": "LD HX,D",
		"\xdd\x63": "LD HX,E",
		"\xdd\x64": "LD HX,HX",
		"\xdd\x65": "LD HX,LX",
		"\xdd\x66\x01": "LD H,(IX+&01)",
		"\xdd\x67": "LD HX,A",
		"\xdd\x68": "LD LX,B",
		"\xdd\x69": "LD LX,C",
		"\xdd\x6a": "LD LX,D",
		"\xdd\x6b": "LD LX,E",
		"\xdd\x6c": "LD LX,HX",
		"\xdd\x6d": "LD LX,LX",
		"\xdd\x6e\x01": "LD L,(IX+&01)",
		"\xdd\x6f": "LD LX,A",
		"\xdd\x70\x01": "LD (IX+&01),B",
		"\xdd\x71\x01": "LD (IX+&01),C",
		"\xdd\x72\x01": "LD (IX+&01),D",
		"\xdd\x73\x01": "LD (IX+&01),E",
		"\xdd\x74\x01": "LD (IX+&01),H",
		"\xdd\x75\x01": "LD (IX+&01),L",
		"\xdd\x76": "HALT",
		"\xdd\x77\x01": "LD (IX+&01),A",
		"\xdd\x78": "LD A,B",
		"\xdd\x79": "LD A,C",
		"\xdd\x7a": "LD A,D",
		"\xdd\x7b": "LD A,E",
		"\xdd\x7c": "LD A,HX",
		"\xdd\x7d": "LD A,LX",
		"\xdd\x7e\x01": "LD A,(IX+&01)",
		"\xdd\x7f": "LD A,A",
		"\xdd\x80": "ADD A,B",
		"\xdd\x81": "ADD A,C",
		"\xdd\x82": "ADD A,D",
		"\xdd\x83": "ADD A,E",
		"\xdd\x84": "ADD A,HX",
		"\xdd\x85": "ADD A,LX",
		"\xdd\x86\x01": "ADD A,(IX+&01)",
		"\xdd\x87": "ADD A,A",
		"\xdd\x88": "ADC A,B",
		"\xdd\x89": "ADC A,C",
		"\xdd\x8a": "ADC A,D",
		"\xdd\x8b": "ADC A,E",
		"\xdd\x8c": "ADC A,HX",
		"\xdd\x8d": "ADC A,LX",
		"\xdd\x8e\x01": "ADC A,(IX+&01)",
		"\xdd\x8f": "ADC A,A",
		"\xdd\x90": "SUB B",
		"\xdd\x91": "SUB C",
		"\xdd\x92": "SUB D",
		"\xdd\x93": "SUB E",
		"\xdd\x94": "SUB HX",
		"\xdd\x95": "SUB LX",
		"\xdd\x96\x01": "SUB (IX+&01)",
		"\xdd\x97": "SUB A",
		"\xdd\x98": "SBC A,B",
		"\xdd\x99": "SBC A,C",
		"\xdd\x9a": "SBC A,D",
		"\xdd\x9b": "SBC A,E",
		"\xdd\x9c": "SBC A,HX",
		"\xdd\x9d": "SBC A,LX",
		"\xdd\x9e\x01": "SBC A,(IX+&01)",
		"\xdd\x9f": "SBC A,A",
		"\xdd\xa0": "AND B",
		"\xdd\xa1": "AND C",
		"\xdd\xa2": "AND D",
		"\xdd\xa3": "AND E",
		"\xdd\xa4": "AND HX",
		"\xdd\xa5": "AND LX",
		"\xdd\xa6\x01": "AND (IX+&01)",
		"\xdd\xa7": "AND A",
		"\xdd\xa8": "XOR B",
		"\xdd\xa9": "XOR C",
		"\xdd\xaa": "XOR D",
		"\xdd\xab": "XOR E",
		"\xdd\xac": "XOR HX",
		"\xdd\xad": "XOR LX",
		"\xdd\xae\x01": "XOR (IX+&01)",
		"\xdd\xaf": "XOR A",
		"\xdd\xb0": "OR B",
		"\xdd\xb1": "OR C",
		"\xdd\xb2": "OR D",
		"\xdd\xb3": "OR E",
		"\xdd\xb4": "OR HX",
		"\xdd\xb5": "OR LX",
		"\xdd\xb6\x01": "OR (IX+&01)",
		"\xdd\xb7": "OR A",
		"\xdd\xb8": "CP B",
		"\xdd\xb9": "CP C",
		"\xdd\xba": "CP D",
		"\xdd\xbb": "CP E",
		"\xdd\xbc": "CP HX",
		"\xdd\xbd": "CP LX",
		"\xdd\xbe\x01": "CP (IX+&01)",
		"\xdd\xbf": "CP A",
		"\xdd\xc0": "RET NZ",
		"\xdd\xc1": "POP BC",
		"\xdd\xc2\x01\x02": "JP NZ,&0201",
		"\xdd\xc3\x01\x02": "JP &0201",
		"\xdd\xc4\x01\x02": "CALL NZ,&0201",
		"\xdd\xc5": "PUSH BC",
		"\xdd\xc6\x01": "ADD A,&01",
		"\xdd\xc7": "RST &00",
		"\xdd\xc8": "RET Z",
		"\xdd\xc9": "RET",
		"\xdd\xca\x01\x02": "JP Z,&0201",
		"\xdd\xcb\x01\x02": "RLC (IX+&01) & LD D",
		"\xdd\xcc\x01\x02": "CALL Z,&0201",
		"\xdd\xcd\x01\x02": "CALL &0201",
		"\xdd\xce\x01": "ADC A,&01",
		"\xdd\xcf": "RST &08",
		"\xdd\xd0": "RET NC",
		"\xdd\xd1": "POP DE",
		"\xdd\xd2\x01\x02": "JP NC,&0201",
		"\xdd\xd3\x01": "OUT (&01),A",
		"\xdd\xd4\x01\x02": "CALL NC,&0201",
		"\xdd\xd5": "PUSH DE",
		"\xdd\xd6\x01": "SUB &01",
		"\xdd\xd7": "RST &10",
		"\xdd\xd8": "RET C",
		"\xdd\xd9": "EXX",
		"\xdd\xda\x01\x02": "JP C,&0201",
		"\xdd\xdb\x01": "IN A,(&01)",
		"\xdd\xdc\x01\x02": "CALL C,&0201",
		"\xdd\xdd": "[DD]-prefix",
		"\xdd\xde\x01": "SBC A,&01",
		"\xdd\xdf": "RST &18",
		"\xdd\xe0": "RET PO",
		"\xdd\xe1": "POP IX",
		"\xdd\xe2\x01\x02": "JP PO,&0201",
		"\xdd\xe3": "EX (SP),IX",
		"\xdd\xe4\x01\x02": "CALL PO,&0201",
		"\xdd\xe5": "PUSH IX",
		"\xdd\xe6\x01": "AND &01",
		"\xdd\xe7": "RST &20",
		"\xdd\xe8": "RET PE",
		"\xdd\xe9": "JP (IX)",
		"\xdd\xea\x01\x02": "JP PE,&0201",
		"\xdd\xeb": "EX DE,HL",
		"\xdd\xec\x01\x02": "CALL PE,&0201",
		"\xdd\xed": "[DD]-prefix",
		"\xdd\xee\x01": "XOR &01",
		"\xdd\xef": "RST &28",
		"\xdd\xf0": "RET P",
		"\xdd\xf1": "POP AF",
		"\xdd\xf2\x01\x02": "JP P,&0201",
		"\xdd\xf3": "DI",
		"\xdd\xf4\x01\x02": "CALL P,&0201",
		"\xdd\xf5": "PUSH AF",
		"\xdd\xf6\x01": "OR &01",
		"\xdd\xf7": "RST &30",
		"\xdd\xf8": "RET M",
		"\xdd\xf9": "LD SP,IX",
		"\xdd\xfa\x01\x02": "JP M,&0201",
		"\xdd\xfb": "EI",
		"\xdd\xfc\x01\x02": "CALL M,&0201",
		"\xdd\xfd": "[DD]-prefix",
		"\xdd\xfe\x01": "CP &01",
		"\xdd\xff": "RST &38"
	},
	prefixDDCB: {
		"\xdd\xcb\x03\x00": "RLC (IX+&03) & LD B",
		"\xdd\xcb\x03\x01": "RLC (IX+&03) & LD C",
		"\xdd\xcb\x03\x02": "RLC (IX+&03) & LD D",
		"\xdd\xcb\x03\x03": "RLC (IX+&03) & LD E",
		"\xdd\xcb\x03\x04": "RLC (IX+&03) & LD H",
		"\xdd\xcb\x03\x05": "RLC (IX+&03) & LD L",
		"\xdd\xcb\x03\x06": "RLC (IX+&03)",
		"\xdd\xcb\x03\x07": "RLC (IX+&03) & LD A",
		"\xdd\xcb\x03\x08": "RRC (IX+&03) & LD B",
		"\xdd\xcb\x03\x09": "RRC (IX+&03) & LD C",
		"\xdd\xcb\x03\x0a": "RRC (IX+&03) & LD D",
		"\xdd\xcb\x03\x0b": "RRC (IX+&03) & LD E",
		"\xdd\xcb\x03\x0c": "RRC (IX+&03) & LD H",
		"\xdd\xcb\x03\x0d": "RRC (IX+&03) & LD L",
		"\xdd\xcb\x03\x0e": "RRC (IX+&03)",
		"\xdd\xcb\x03\x0f": "RRC (IX+&03) & LD A",
		"\xdd\xcb\x03\x10": "RL (IX+&03) & LD B",
		"\xdd\xcb\x03\x11": "RL (IX+&03) & LD C",
		"\xdd\xcb\x03\x12": "RL (IX+&03) & LD D",
		"\xdd\xcb\x03\x13": "RL (IX+&03) & LD E",
		"\xdd\xcb\x03\x14": "RL (IX+&03) & LD H",
		"\xdd\xcb\x03\x15": "RL (IX+&03) & LD L",
		"\xdd\xcb\x03\x16": "RL (IX+&03)",
		"\xdd\xcb\x03\x17": "RL (IX+&03) & LD A",
		"\xdd\xcb\x03\x18": "RR (IX+&03) & LD B",
		"\xdd\xcb\x03\x19": "RR (IX+&03) & LD C",
		"\xdd\xcb\x03\x1a": "RR (IX+&03) & LD D",
		"\xdd\xcb\x03\x1b": "RR (IX+&03) & LD E",
		"\xdd\xcb\x03\x1c": "RR (IX+&03) & LD H",
		"\xdd\xcb\x03\x1d": "RR (IX+&03) & LD L",
		"\xdd\xcb\x03\x1e": "RR (IX+&03)",
		"\xdd\xcb\x03\x1f": "RR (IX+&03) & LD A",
		"\xdd\xcb\x03\x20": "SLA (IX+&03) & LD B",
		"\xdd\xcb\x03\x21": "SLA (IX+&03) & LD C",
		"\xdd\xcb\x03\x22": "SLA (IX+&03) & LD D",
		"\xdd\xcb\x03\x23": "SLA (IX+&03) & LD E",
		"\xdd\xcb\x03\x24": "SLA (IX+&03) & LD H",
		"\xdd\xcb\x03\x25": "SLA (IX+&03) & LD L",
		"\xdd\xcb\x03\x26": "SLA (IX+&03)",
		"\xdd\xcb\x03\x27": "SLA (IX+&03) & LD A",
		"\xdd\xcb\x03\x28": "SRA (IX+&03) & LD B",
		"\xdd\xcb\x03\x29": "SRA (IX+&03) & LD C",
		"\xdd\xcb\x03\x2a": "SRA (IX+&03) & LD D",
		"\xdd\xcb\x03\x2b": "SRA (IX+&03) & LD E",
		"\xdd\xcb\x03\x2c": "SRA (IX+&03) & LD H",
		"\xdd\xcb\x03\x2d": "SRA (IX+&03) & LD L",
		"\xdd\xcb\x03\x2e": "SRA (IX+&03)",
		"\xdd\xcb\x03\x2f": "SRA (IX+&03) & LD A",
		"\xdd\xcb\x03\x30": "SLS* (IX+&03) & LD B",
		"\xdd\xcb\x03\x31": "SLS* (IX+&03) & LD C",
		"\xdd\xcb\x03\x32": "SLS* (IX+&03) & LD D",
		"\xdd\xcb\x03\x33": "SLS* (IX+&03) & LD E",
		"\xdd\xcb\x03\x34": "SLS* (IX+&03) & LD H",
		"\xdd\xcb\x03\x35": "SLS* (IX+&03) & LD L",
		"\xdd\xcb\x03\x36": "SLS* (IX+&03)",
		"\xdd\xcb\x03\x37": "SLS* (IX+&03) & LD A",
		"\xdd\xcb\x03\x38": "SRL (IX+&03) & LD B",
		"\xdd\xcb\x03\x39": "SRL (IX+&03) & LD C",
		"\xdd\xcb\x03\x3a": "SRL (IX+&03) & LD D",
		"\xdd\xcb\x03\x3b": "SRL (IX+&03) & LD E",
		"\xdd\xcb\x03\x3c": "SRL (IX+&03) & LD H",
		"\xdd\xcb\x03\x3d": "SRL (IX+&03) & LD L",
		"\xdd\xcb\x03\x3e": "SRL (IX+&03)",
		"\xdd\xcb\x03\x3f": "SRL (IX+&03) & LD A",
		"\xdd\xcb\x03\x40": "BIT 0,(IX+&03)",
		"\xdd\xcb\x03\x41": "BIT 0,(IX+&03)",
		"\xdd\xcb\x03\x42": "BIT 0,(IX+&03)",
		"\xdd\xcb\x03\x43": "BIT 0,(IX+&03)",
		"\xdd\xcb\x03\x44": "BIT 0,(IX+&03)",
		"\xdd\xcb\x03\x45": "BIT 0,(IX+&03)",
		"\xdd\xcb\x03\x46": "BIT 0,(IX+&03)",
		"\xdd\xcb\x03\x47": "BIT 0,(IX+&03)",
		"\xdd\xcb\x03\x48": "BIT 1,(IX+&03)",
		"\xdd\xcb\x03\x49": "BIT 1,(IX+&03)",
		"\xdd\xcb\x03\x4a": "BIT 1,(IX+&03)",
		"\xdd\xcb\x03\x4b": "BIT 1,(IX+&03)",
		"\xdd\xcb\x03\x4c": "BIT 1,(IX+&03)",
		"\xdd\xcb\x03\x4d": "BIT 1,(IX+&03)",
		"\xdd\xcb\x03\x4e": "BIT 1,(IX+&03)",
		"\xdd\xcb\x03\x4f": "BIT 1,(IX+&03)",
		"\xdd\xcb\x03\x50": "BIT 2,(IX+&03)",
		"\xdd\xcb\x03\x51": "BIT 2,(IX+&03)",
		"\xdd\xcb\x03\x52": "BIT 2,(IX+&03)",
		"\xdd\xcb\x03\x53": "BIT 2,(IX+&03)",
		"\xdd\xcb\x03\x54": "BIT 2,(IX+&03)",
		"\xdd\xcb\x03\x55": "BIT 2,(IX+&03)",
		"\xdd\xcb\x03\x56": "BIT 2,(IX+&03)",
		"\xdd\xcb\x03\x57": "BIT 2,(IX+&03)",
		"\xdd\xcb\x03\x58": "BIT 3,(IX+&03)",
		"\xdd\xcb\x03\x59": "BIT 3,(IX+&03)",
		"\xdd\xcb\x03\x5a": "BIT 3,(IX+&03)",
		"\xdd\xcb\x03\x5b": "BIT 3,(IX+&03)",
		"\xdd\xcb\x03\x5c": "BIT 3,(IX+&03)",
		"\xdd\xcb\x03\x5d": "BIT 3,(IX+&03)",
		"\xdd\xcb\x03\x5e": "BIT 3,(IX+&03)",
		"\xdd\xcb\x03\x5f": "BIT 3,(IX+&03)",
		"\xdd\xcb\x03\x60": "BIT 4,(IX+&03)",
		"\xdd\xcb\x03\x61": "BIT 4,(IX+&03)",
		"\xdd\xcb\x03\x62": "BIT 4,(IX+&03)",
		"\xdd\xcb\x03\x63": "BIT 4,(IX+&03)",
		"\xdd\xcb\x03\x64": "BIT 4,(IX+&03)",
		"\xdd\xcb\x03\x65": "BIT 4,(IX+&03)",
		"\xdd\xcb\x03\x66": "BIT 4,(IX+&03)",
		"\xdd\xcb\x03\x67": "BIT 4,(IX+&03)",
		"\xdd\xcb\x03\x68": "BIT 5,(IX+&03)",
		"\xdd\xcb\x03\x69": "BIT 5,(IX+&03)",
		"\xdd\xcb\x03\x6a": "BIT 5,(IX+&03)",
		"\xdd\xcb\x03\x6b": "BIT 5,(IX+&03)",
		"\xdd\xcb\x03\x6c": "BIT 5,(IX+&03)",
		"\xdd\xcb\x03\x6d": "BIT 5,(IX+&03)",
		"\xdd\xcb\x03\x6e": "BIT 5,(IX+&03)",
		"\xdd\xcb\x03\x6f": "BIT 5,(IX+&03)",
		"\xdd\xcb\x03\x70": "BIT 6,(IX+&03)",
		"\xdd\xcb\x03\x71": "BIT 6,(IX+&03)",
		"\xdd\xcb\x03\x72": "BIT 6,(IX+&03)",
		"\xdd\xcb\x03\x73": "BIT 6,(IX+&03)",
		"\xdd\xcb\x03\x74": "BIT 6,(IX+&03)",
		"\xdd\xcb\x03\x75": "BIT 6,(IX+&03)",
		"\xdd\xcb\x03\x76": "BIT 6,(IX+&03)",
		"\xdd\xcb\x03\x77": "BIT 6,(IX+&03)",
		"\xdd\xcb\x03\x78": "BIT 7,(IX+&03)",
		"\xdd\xcb\x03\x79": "BIT 7,(IX+&03)",
		"\xdd\xcb\x03\x7a": "BIT 7,(IX+&03)",
		"\xdd\xcb\x03\x7b": "BIT 7,(IX+&03)",
		"\xdd\xcb\x03\x7c": "BIT 7,(IX+&03)",
		"\xdd\xcb\x03\x7d": "BIT 7,(IX+&03)",
		"\xdd\xcb\x03\x7e": "BIT 7,(IX+&03)",
		"\xdd\xcb\x03\x7f": "BIT 7,(IX+&03)",
		"\xdd\xcb\x03\x80": "RES 0,(IX+&03) & LD B",
		"\xdd\xcb\x03\x81": "RES 0,(IX+&03) & LD C",
		"\xdd\xcb\x03\x82": "RES 0,(IX+&03) & LD D",
		"\xdd\xcb\x03\x83": "RES 0,(IX+&03) & LD E",
		"\xdd\xcb\x03\x84": "RES 0,(IX+&03) & LD H",
		"\xdd\xcb\x03\x85": "RES 0,(IX+&03) & LD L",
		"\xdd\xcb\x03\x86": "RES 0,(IX+&03)",
		"\xdd\xcb\x03\x87": "RES 0,(IX+&03) & LD A",
		"\xdd\xcb\x03\x88": "RES 1,(IX+&03) & LD B",
		"\xdd\xcb\x03\x89": "RES 1,(IX+&03) & LD C",
		"\xdd\xcb\x03\x8a": "RES 1,(IX+&03) & LD D",
		"\xdd\xcb\x03\x8b": "RES 1,(IX+&03) & LD E",
		"\xdd\xcb\x03\x8c": "RES 1,(IX+&03) & LD H",
		"\xdd\xcb\x03\x8d": "RES 1,(IX+&03) & LD L",
		"\xdd\xcb\x03\x8e": "RES 1,(IX+&03)",
		"\xdd\xcb\x03\x8f": "RES 1,(IX+&03) & LD A",
		"\xdd\xcb\x03\x90": "RES 2,(IX+&03) & LD B",
		"\xdd\xcb\x03\x91": "RES 2,(IX+&03) & LD C",
		"\xdd\xcb\x03\x92": "RES 2,(IX+&03) & LD D",
		"\xdd\xcb\x03\x93": "RES 2,(IX+&03) & LD E",
		"\xdd\xcb\x03\x94": "RES 2,(IX+&03) & LD H",
		"\xdd\xcb\x03\x95": "RES 2,(IX+&03) & LD L",
		"\xdd\xcb\x03\x96": "RES 2,(IX+&03)",
		"\xdd\xcb\x03\x97": "RES 2,(IX+&03) & LD A",
		"\xdd\xcb\x03\x98": "RES 3,(IX+&03) & LD B",
		"\xdd\xcb\x03\x99": "RES 3,(IX+&03) & LD C",
		"\xdd\xcb\x03\x9a": "RES 3,(IX+&03) & LD D",
		"\xdd\xcb\x03\x9b": "RES 3,(IX+&03) & LD E",
		"\xdd\xcb\x03\x9c": "RES 3,(IX+&03) & LD H",
		"\xdd\xcb\x03\x9d": "RES 3,(IX+&03) & LD L",
		"\xdd\xcb\x03\x9e": "RES 3,(IX+&03)",
		"\xdd\xcb\x03\x9f": "RES 3,(IX+&03) & LD A",
		"\xdd\xcb\x03\xa0": "RES 4,(IX+&03) & LD B",
		"\xdd\xcb\x03\xa1": "RES 4,(IX+&03) & LD C",
		"\xdd\xcb\x03\xa2": "RES 4,(IX+&03) & LD D",
		"\xdd\xcb\x03\xa3": "RES 4,(IX+&03) & LD E",
		"\xdd\xcb\x03\xa4": "RES 4,(IX+&03) & LD H",
		"\xdd\xcb\x03\xa5": "RES 4,(IX+&03) & LD L",
		"\xdd\xcb\x03\xa6": "RES 4,(IX+&03)",
		"\xdd\xcb\x03\xa7": "RES 4,(IX+&03) & LD A",
		"\xdd\xcb\x03\xa8": "RES 5,(IX+&03) & LD B",
		"\xdd\xcb\x03\xa9": "RES 5,(IX+&03) & LD C",
		"\xdd\xcb\x03\xaa": "RES 5,(IX+&03) & LD D",
		"\xdd\xcb\x03\xab": "RES 5,(IX+&03) & LD E",
		"\xdd\xcb\x03\xac": "RES 5,(IX+&03) & LD H",
		"\xdd\xcb\x03\xad": "RES 5,(IX+&03) & LD L",
		"\xdd\xcb\x03\xae": "RES 5,(IX+&03)",
		"\xdd\xcb\x03\xaf": "RES 5,(IX+&03) & LD A",
		"\xdd\xcb\x03\xb0": "RES 6,(IX+&03) & LD B",
		"\xdd\xcb\x03\xb1": "RES 6,(IX+&03) & LD C",
		"\xdd\xcb\x03\xb2": "RES 6,(IX+&03) & LD D",
		"\xdd\xcb\x03\xb3": "RES 6,(IX+&03) & LD E",
		"\xdd\xcb\x03\xb4": "RES 6,(IX+&03) & LD H",
		"\xdd\xcb\x03\xb5": "RES 6,(IX+&03) & LD L",
		"\xdd\xcb\x03\xb6": "RES 6,(IX+&03)",
		"\xdd\xcb\x03\xb7": "RES 6,(IX+&03) & LD A",
		"\xdd\xcb\x03\xb8": "RES 7,(IX+&03) & LD B",
		"\xdd\xcb\x03\xb9": "RES 7,(IX+&03) & LD C",
		"\xdd\xcb\x03\xba": "RES 7,(IX+&03) & LD D",
		"\xdd\xcb\x03\xbb": "RES 7,(IX+&03) & LD E",
		"\xdd\xcb\x03\xbc": "RES 7,(IX+&03) & LD H",
		"\xdd\xcb\x03\xbd": "RES 7,(IX+&03) & LD L",
		"\xdd\xcb\x03\xbe": "RES 7,(IX+&03)",
		"\xdd\xcb\x03\xbf": "RES 7,(IX+&03) & LD A",
		"\xdd\xcb\x03\xc0": "SET 0,(IX+&03) & LD B",
		"\xdd\xcb\x03\xc1": "SET 0,(IX+&03) & LD C",
		"\xdd\xcb\x03\xc2": "SET 0,(IX+&03) & LD D",
		"\xdd\xcb\x03\xc3": "SET 0,(IX+&03) & LD E",
		"\xdd\xcb\x03\xc4": "SET 0,(IX+&03) & LD H",
		"\xdd\xcb\x03\xc5": "SET 0,(IX+&03) & LD L",
		"\xdd\xcb\x03\xc6": "SET 0,(IX+&03)",
		"\xdd\xcb\x03\xc7": "SET 0,(IX+&03) & LD A",
		"\xdd\xcb\x03\xc8": "SET 1,(IX+&03) & LD B",
		"\xdd\xcb\x03\xc9": "SET 1,(IX+&03) & LD C",
		"\xdd\xcb\x03\xca": "SET 1,(IX+&03) & LD D",
		"\xdd\xcb\x03\xcb": "SET 1,(IX+&03) & LD E",
		"\xdd\xcb\x03\xcc": "SET 1,(IX+&03) & LD H",
		"\xdd\xcb\x03\xcd": "SET 1,(IX+&03) & LD L",
		"\xdd\xcb\x03\xce": "SET 1,(IX+&03)",
		"\xdd\xcb\x03\xcf": "SET 1,(IX+&03) & LD A",
		"\xdd\xcb\x03\xd0": "SET 2,(IX+&03) & LD B",
		"\xdd\xcb\x03\xd1": "SET 2,(IX+&03) & LD C",
		"\xdd\xcb\x03\xd2": "SET 2,(IX+&03) & LD D",
		"\xdd\xcb\x03\xd3": "SET 2,(IX+&03) & LD E",
		"\xdd\xcb\x03\xd4": "SET 2,(IX+&03) & LD H",
		"\xdd\xcb\x03\xd5": "SET 2,(IX+&03) & LD L",
		"\xdd\xcb\x03\xd6": "SET 2,(IX+&03)",
		"\xdd\xcb\x03\xd7": "SET 2,(IX+&03) & LD A",
		"\xdd\xcb\x03\xd8": "SET 3,(IX+&03) & LD B",
		"\xdd\xcb\x03\xd9": "SET 3,(IX+&03) & LD C",
		"\xdd\xcb\x03\xda": "SET 3,(IX+&03) & LD D",
		"\xdd\xcb\x03\xdb": "SET 3,(IX+&03) & LD E",
		"\xdd\xcb\x03\xdc": "SET 3,(IX+&03) & LD H",
		"\xdd\xcb\x03\xdd": "SET 3,(IX+&03) & LD L",
		"\xdd\xcb\x03\xde": "SET 3,(IX+&03)",
		"\xdd\xcb\x03\xdf": "SET 3,(IX+&03) & LD A",
		"\xdd\xcb\x03\xe0": "SET 4,(IX+&03) & LD B",
		"\xdd\xcb\x03\xe1": "SET 4,(IX+&03) & LD C",
		"\xdd\xcb\x03\xe2": "SET 4,(IX+&03) & LD D",
		"\xdd\xcb\x03\xe3": "SET 4,(IX+&03) & LD E",
		"\xdd\xcb\x03\xe4": "SET 4,(IX+&03) & LD H",
		"\xdd\xcb\x03\xe5": "SET 4,(IX+&03) & LD L",
		"\xdd\xcb\x03\xe6": "SET 4,(IX+&03)",
		"\xdd\xcb\x03\xe7": "SET 4,(IX+&03) & LD A",
		"\xdd\xcb\x03\xe8": "SET 5,(IX+&03) & LD B",
		"\xdd\xcb\x03\xe9": "SET 5,(IX+&03) & LD C",
		"\xdd\xcb\x03\xea": "SET 5,(IX+&03) & LD D",
		"\xdd\xcb\x03\xeb": "SET 5,(IX+&03) & LD E",
		"\xdd\xcb\x03\xec": "SET 5,(IX+&03) & LD H",
		"\xdd\xcb\x03\xed": "SET 5,(IX+&03) & LD L",
		"\xdd\xcb\x03\xee": "SET 5,(IX+&03)",
		"\xdd\xcb\x03\xef": "SET 5,(IX+&03) & LD A",
		"\xdd\xcb\x03\xf0": "SET 6,(IX+&03) & LD B",
		"\xdd\xcb\x03\xf1": "SET 6,(IX+&03) & LD C",
		"\xdd\xcb\x03\xf2": "SET 6,(IX+&03) & LD D",
		"\xdd\xcb\x03\xf3": "SET 6,(IX+&03) & LD E",
		"\xdd\xcb\x03\xf4": "SET 6,(IX+&03) & LD H",
		"\xdd\xcb\x03\xf5": "SET 6,(IX+&03) & LD L",
		"\xdd\xcb\x03\xf6": "SET 6,(IX+&03)",
		"\xdd\xcb\x03\xf7": "SET 6,(IX+&03) & LD A",
		"\xdd\xcb\x03\xf8": "SET 7,(IX+&03) & LD B",
		"\xdd\xcb\x03\xf9": "SET 7,(IX+&03) & LD C",
		"\xdd\xcb\x03\xfa": "SET 7,(IX+&03) & LD D",
		"\xdd\xcb\x03\xfb": "SET 7,(IX+&03) & LD E",
		"\xdd\xcb\x03\xfc": "SET 7,(IX+&03) & LD H",
		"\xdd\xcb\x03\xfd": "SET 7,(IX+&03) & LD L",
		"\xdd\xcb\x03\xfe": "SET 7,(IX+&03)",
		"\xdd\xcb\x03\xff": "SET 7,(IX+&03) & LD A"
	},
	prefixED: {
		"\xed\x00": "unknown",
		"\xed\x01": "unknown",
		"\xed\x02": "unknown",
		"\xed\x03": "unknown",
		"\xed\x04": "unknown",
		"\xed\x05": "unknown",
		"\xed\x06": "unknown",
		"\xed\x07": "unknown",
		"\xed\x08": "unknown",
		"\xed\x09": "unknown",
		"\xed\x0a": "unknown",
		"\xed\x0b": "unknown",
		"\xed\x0c": "unknown",
		"\xed\x0d": "unknown",
		"\xed\x0e": "unknown",
		"\xed\x0f": "unknown",
		"\xed\x10": "unknown",
		"\xed\x11": "unknown",
		"\xed\x12": "unknown",
		"\xed\x13": "unknown",
		"\xed\x14": "unknown",
		"\xed\x15": "unknown",
		"\xed\x16": "unknown",
		"\xed\x17": "unknown",
		"\xed\x18": "unknown",
		"\xed\x19": "unknown",
		"\xed\x1a": "unknown",
		"\xed\x1b": "unknown",
		"\xed\x1c": "unknown",
		"\xed\x1d": "unknown",
		"\xed\x1e": "unknown",
		"\xed\x1f": "unknown",
		"\xed\x20": "unknown",
		"\xed\x21": "unknown",
		"\xed\x22": "unknown",
		"\xed\x23": "unknown",
		"\xed\x24": "unknown",
		"\xed\x25": "unknown",
		"\xed\x26": "unknown",
		"\xed\x27": "unknown",
		"\xed\x28": "unknown",
		"\xed\x29": "unknown",
		"\xed\x2a": "unknown",
		"\xed\x2b": "unknown",
		"\xed\x2c": "unknown",
		"\xed\x2d": "unknown",
		"\xed\x2e": "unknown",
		"\xed\x2f": "unknown",
		"\xed\x30": "unknown",
		"\xed\x31": "unknown",
		"\xed\x32": "unknown",
		"\xed\x33": "unknown",
		"\xed\x34": "unknown",
		"\xed\x35": "unknown",
		"\xed\x36": "unknown",
		"\xed\x37": "unknown",
		"\xed\x38": "unknown",
		"\xed\x39": "unknown",
		"\xed\x3a": "unknown",
		"\xed\x3b": "unknown",
		"\xed\x3c": "unknown",
		"\xed\x3d": "unknown",
		"\xed\x3e": "unknown",
		"\xed\x3f": "unknown",
		"\xed\x40": "IN B,(C)",
		"\xed\x41": "OUT (C),B",
		"\xed\x42": "SBC HL,BC",
		"\xed\x43\x01\x02": "LD (&0201),BC",
		"\xed\x44": "NEG",
		"\xed\x45": "RETN",
		"\xed\x46": "IM 0",
		"\xed\x47": "LD I,A",
		"\xed\x48": "IN C,(C)",
		"\xed\x49": "OUT (C),C",
		"\xed\x4a": "ADC HL,BC",
		"\xed\x4b\x01\x02": "LD BC,(&0201)",
		"\xed\x4c": "*NEG",
		"\xed\x4d": "RETI",
		"\xed\x4e": "*IM 0",
		"\xed\x4f": "LD R,A",
		"\xed\x50": "IN D,(C)",
		"\xed\x51": "OUT (C),D",
		"\xed\x52": "SBC HL,DE",
		"\xed\x53\x01\x02": "LD (&0201),DE",
		"\xed\x54": "*NEG",
		"\xed\x55": "*RETN",
		"\xed\x56": "IM 1",
		"\xed\x57": "LD A,I",
		"\xed\x58": "IN E,(C)",
		"\xed\x59": "OUT (C),E",
		"\xed\x5a": "ADC HL,DE",
		"\xed\x5b\x01\x02": "LD DE,(&0201)",
		"\xed\x5c": "*NEG",
		"\xed\x5d": "*RETI",
		"\xed\x5e": "IM 2",
		"\xed\x5f": "LD A,R",
		"\xed\x60": "IN H,(C)",
		"\xed\x61": "OUT (C),H",
		"\xed\x62": "SBC HL,HL",
		"\xed\x63\x01\x02": "LD (&0201),HL",
		"\xed\x64": "*NEG",
		"\xed\x65": "*RETN",
		"\xed\x66": "*IM 0",
		"\xed\x67": "RRD",
		"\xed\x68": "IN L,(C)",
		"\xed\x69": "OUT (C),L",
		"\xed\x6a": "ADC HL,HL",
		"\xed\x6b\x01\x02": "LD HL,(&0201)",
		"\xed\x6c": "*NEG",
		"\xed\x6d": "*RETI",
		"\xed\x6e": "*IM 0",
		"\xed\x6f": "RLD",
		"\xed\x70": "*IN X,(C)",
		"\xed\x71": "*OUT (C),0",
		"\xed\x72": "SBC HL,SP",
		"\xed\x73\x01\x02": "LD (&0201),SP",
		"\xed\x74": "*NEG",
		"\xed\x75": "*RETN",
		"\xed\x76": "*IM 1",
		"\xed\x77": "unknown",
		"\xed\x78": "IN A,(C)",
		"\xed\x79": "OUT (C),A",
		"\xed\x7a": "ADC HL,SP",
		"\xed\x7b\x01\x02": "LD SP,(&0201)",
		"\xed\x7c": "*NEG",
		"\xed\x7d": "*RETI",
		"\xed\x7e": "*IM 2",
		"\xed\x7f": "unknown",
		"\xed\x80": "unknown",
		"\xed\x81": "unknown",
		"\xed\x82": "unknown",
		"\xed\x83": "unknown",
		"\xed\x84": "unknown",
		"\xed\x85": "unknown",
		"\xed\x86": "unknown",
		"\xed\x87": "unknown",
		"\xed\x88": "unknown",
		"\xed\x89": "unknown",
		"\xed\x8a": "unknown",
		"\xed\x8b": "unknown",
		"\xed\x8c": "unknown",
		"\xed\x8d": "unknown",
		"\xed\x8e": "unknown",
		"\xed\x8f": "unknown",
		"\xed\x90": "unknown",
		"\xed\x91": "unknown",
		"\xed\x92": "unknown",
		"\xed\x93": "unknown",
		"\xed\x94": "unknown",
		"\xed\x95": "unknown",
		"\xed\x96": "unknown",
		"\xed\x97": "unknown",
		"\xed\x98": "unknown",
		"\xed\x99": "unknown",
		"\xed\x9a": "unknown",
		"\xed\x9b": "unknown",
		"\xed\x9c": "unknown",
		"\xed\x9d": "unknown",
		"\xed\x9e": "unknown",
		"\xed\x9f": "unknown",
		"\xed\xa0": "LDI",
		"\xed\xa1": "CPI",
		"\xed\xa2": "INI",
		"\xed\xa3": "OUTI",
		"\xed\xa4": "unknown",
		"\xed\xa5": "unknown",
		"\xed\xa6": "unknown",
		"\xed\xa7": "unknown",
		"\xed\xa8": "LDD",
		"\xed\xa9": "CPD",
		"\xed\xaa": "IND",
		"\xed\xab": "OUTD",
		"\xed\xac": "unknown",
		"\xed\xad": "unknown",
		"\xed\xae": "unknown",
		"\xed\xaf": "unknown",
		"\xed\xb0": "LDIR",
		"\xed\xb1": "CPIR",
		"\xed\xb2": "INIR",
		"\xed\xb3": "OTIR",
		"\xed\xb4": "unknown",
		"\xed\xb5": "unknown",
		"\xed\xb6": "unknown",
		"\xed\xb7": "unknown",
		"\xed\xb8": "LDDR",
		"\xed\xb9": "CPDR",
		"\xed\xba": "INDR",
		"\xed\xbb": "OTDR",
		"\xed\xbc": "unknown",
		"\xed\xbd": "unknown",
		"\xed\xbe": "unknown",
		"\xed\xbf": "unknown",
		"\xed\xc0": "unknown",
		"\xed\xc1": "unknown",
		"\xed\xc2": "unknown",
		"\xed\xc3": "unknown",
		"\xed\xc4": "unknown",
		"\xed\xc5": "unknown",
		"\xed\xc6": "unknown",
		"\xed\xc7": "unknown",
		"\xed\xc8": "unknown",
		"\xed\xc9": "unknown",
		"\xed\xca": "unknown",
		"\xed\xcb": "unknown",
		"\xed\xcc": "unknown",
		"\xed\xcd": "unknown",
		"\xed\xce": "unknown",
		"\xed\xcf": "unknown",
		"\xed\xd0": "unknown",
		"\xed\xd1": "unknown",
		"\xed\xd2": "unknown",
		"\xed\xd3": "unknown",
		"\xed\xd4": "unknown",
		"\xed\xd5": "unknown",
		"\xed\xd6": "unknown",
		"\xed\xd7": "unknown",
		"\xed\xd8": "unknown",
		"\xed\xd9": "unknown",
		"\xed\xda": "unknown",
		"\xed\xdb": "unknown",
		"\xed\xdc": "unknown",
		"\xed\xdd": "unknown",
		"\xed\xde": "unknown",
		"\xed\xdf": "unknown",
		"\xed\xe0": "unknown",
		"\xed\xe1": "unknown",
		"\xed\xe2": "unknown",
		"\xed\xe3": "unknown",
		"\xed\xe4": "unknown",
		"\xed\xe5": "unknown",
		"\xed\xe6": "unknown",
		"\xed\xe7": "unknown",
		"\xed\xe8": "unknown",
		"\xed\xe9": "unknown",
		"\xed\xea": "unknown",
		"\xed\xeb": "unknown",
		"\xed\xec": "unknown",
		"\xed\xed": "unknown",
		"\xed\xee": "unknown",
		"\xed\xef": "unknown",
		"\xed\xf0": "unknown",
		"\xed\xf1": "unknown",
		"\xed\xf2": "unknown",
		"\xed\xf3": "unknown",
		"\xed\xf4": "unknown",
		"\xed\xf5": "unknown",
		"\xed\xf6": "unknown",
		"\xed\xf7": "unknown",
		"\xed\xf8": "unknown",
		"\xed\xf9": "unknown",
		"\xed\xfa": "unknown",
		"\xed\xfb": "unknown",
		"\xed\xfc": "unknown",
		"\xed\xfd": "unknown",
		"\xed\xfe": "unknown",
		"\xed\xff": "unknown"
	},
	prefixFD: {
		"\xfd\x00": "NOP",
		"\xfd\x01\x01\x02": "LD BC,&0201",
		"\xfd\x02": "LD (BC),A",
		"\xfd\x03": "INC BC",
		"\xfd\x04": "INC B",
		"\xfd\x05": "DEC B",
		"\xfd\x06\x01": "LD B,&01",
		"\xfd\x07": "RLCA",
		"\xfd\x08": "EX AF,AF'",
		"\xfd\x09": "ADD IY,BC",
		"\xfd\x0a": "LD A,(BC)",
		"\xfd\x0b": "DEC BC",
		"\xfd\x0c": "INC C",
		"\xfd\x0d": "DEC C",
		"\xfd\x0e\x01": "LD C,&01",
		"\xfd\x0f": "RRCA",
		"\xfd\x10\x01": "DJNZ &0004",
		"\xfd\x11\x01\x02": "LD DE,&0201",
		"\xfd\x12": "LD (DE),A",
		"\xfd\x13": "INC DE",
		"\xfd\x14": "INC D",
		"\xfd\x15": "DEC D",
		"\xfd\x16\x01": "LD D,&01",
		"\xfd\x17": "RLA",
		"\xfd\x18\x01": "JR &0004",
		"\xfd\x19": "ADD IY,DE",
		"\xfd\x1a": "LD A,(DE)",
		"\xfd\x1b": "DEC DE",
		"\xfd\x1c": "INC E",
		"\xfd\x1d": "DEC E",
		"\xfd\x1e\x01": "LD E,&01",
		"\xfd\x1f": "RRA",
		"\xfd\x20\x01": "JR NZ,&0004",
		"\xfd\x21\x01\x02": "LD IY,&0201",
		"\xfd\x22\x01\x02": "LD (&0201),IY",
		"\xfd\x23": "INC IY",
		"\xfd\x24": "INC HY",
		"\xfd\x25": "DEC HY",
		"\xfd\x26\x01": "LD HY,&01",
		"\xfd\x27": "DAA",
		"\xfd\x28\x01": "JR Z,&0004",
		"\xfd\x29": "ADD IY,IY",
		"\xfd\x2a\x01\x02": "LD IY,(&0201)",
		"\xfd\x2b": "DEC IY",
		"\xfd\x2c": "INC LY",
		"\xfd\x2d": "DEC LY",
		"\xfd\x2e\x01": "LD LY,&01",
		"\xfd\x2f": "CPL",
		"\xfd\x30\x01": "JR NC,&0004",
		"\xfd\x31\x01\x02": "LD SP,&0201",
		"\xfd\x32\x01\x02": "LD (&0201),A",
		"\xfd\x33": "INC SP",
		"\xfd\x34\x01": "INC (IY+&01)",
		"\xfd\x35\x01": "DEC (IY+&01)",
		"\xfd\x36\x01\x02": "LD (IY+&01),&02",
		"\xfd\x37": "SCF",
		"\xfd\x38\x01": "JR C,&0004",
		"\xfd\x39": "ADD IY,SP",
		"\xfd\x3a\x01\x02": "LD A,(&0201)",
		"\xfd\x3b": "DEC SP",
		"\xfd\x3c": "INC A",
		"\xfd\x3d": "DEC A",
		"\xfd\x3e\x01": "LD A,&01",
		"\xfd\x3f": "CCF",
		"\xfd\x40": "LD B,B",
		"\xfd\x41": "LD B,C",
		"\xfd\x42": "LD B,D",
		"\xfd\x43": "LD B,E",
		"\xfd\x44": "LD B,HY",
		"\xfd\x45": "LD B,LY",
		"\xfd\x46\x01": "LD B,(IY+&01)",
		"\xfd\x47": "LD B,A",
		"\xfd\x48": "LD C,B",
		"\xfd\x49": "LD C,C",
		"\xfd\x4a": "LD C,D",
		"\xfd\x4b": "LD C,E",
		"\xfd\x4c": "LD C,HY",
		"\xfd\x4d": "LD C,LY",
		"\xfd\x4e\x01": "LD C,(IY+&01)",
		"\xfd\x4f": "LD C,A",
		"\xfd\x50": "LD D,B",
		"\xfd\x51": "LD D,C",
		"\xfd\x52": "LD D,D",
		"\xfd\x53": "LD D,E",
		"\xfd\x54": "LD D,HY",
		"\xfd\x55": "LD D,LY",
		"\xfd\x56\x01": "LD D,(IY+&01)",
		"\xfd\x57": "LD D,A",
		"\xfd\x58": "LD E,B",
		"\xfd\x59": "LD E,C",
		"\xfd\x5a": "LD E,D",
		"\xfd\x5b": "LD E,E",
		"\xfd\x5c": "LD E,HY",
		"\xfd\x5d": "LD E,LY",
		"\xfd\x5e\x01": "LD E,(IY+&01)",
		"\xfd\x5f": "LD E,A",
		"\xfd\x60": "LD HY,B",
		"\xfd\x61": "LD HY,C",
		"\xfd\x62": "LD HY,D",
		"\xfd\x63": "LD HY,E",
		"\xfd\x64": "LD HY,HY",
		"\xfd\x65": "LD HY,LY",
		"\xfd\x66\x01": "LD H,(IY+&01)",
		"\xfd\x67": "LD HY,A",
		"\xfd\x68": "LD LY,B",
		"\xfd\x69": "LD LY,C",
		"\xfd\x6a": "LD LY,D",
		"\xfd\x6b": "LD LY,E",
		"\xfd\x6c": "LD LY,HY",
		"\xfd\x6d": "LD LY,LY",
		"\xfd\x6e\x01": "LD L,(IY+&01)",
		"\xfd\x6f": "LD LY,A",
		"\xfd\x70\x01": "LD (IY+&01),B",
		"\xfd\x71\x01": "LD (IY+&01),C",
		"\xfd\x72\x01": "LD (IY+&01),D",
		"\xfd\x73\x01": "LD (IY+&01),E",
		"\xfd\x74\x01": "LD (IY+&01),H",
		"\xfd\x75\x01": "LD (IY+&01),L",
		"\xfd\x76": "HALT",
		"\xfd\x77\x01": "LD (IY+&01),A",
		"\xfd\x78": "LD A,B",
		"\xfd\x79": "LD A,C",
		"\xfd\x7a": "LD A,D",
		"\xfd\x7b": "LD A,E",
		"\xfd\x7c": "LD A,HY",
		"\xfd\x7d": "LD A,LY",
		"\xfd\x7e\x01": "LD A,(IY+&01)",
		"\xfd\x7f": "LD A,A",
		"\xfd\x80": "ADD A,B",
		"\xfd\x81": "ADD A,C",
		"\xfd\x82": "ADD A,D",
		"\xfd\x83": "ADD A,E",
		"\xfd\x84": "ADD A,HY",
		"\xfd\x85": "ADD A,LY",
		"\xfd\x86\x01": "ADD A,(IY+&01)",
		"\xfd\x87": "ADD A,A",
		"\xfd\x88": "ADC A,B",
		"\xfd\x89": "ADC A,C",
		"\xfd\x8a": "ADC A,D",
		"\xfd\x8b": "ADC A,E",
		"\xfd\x8c": "ADC A,HY",
		"\xfd\x8d": "ADC A,LY",
		"\xfd\x8e\x01": "ADC A,(IY+&01)",
		"\xfd\x8f": "ADC A,A",
		"\xfd\x90": "SUB B",
		"\xfd\x91": "SUB C",
		"\xfd\x92": "SUB D",
		"\xfd\x93": "SUB E",
		"\xfd\x94": "SUB HY",
		"\xfd\x95": "SUB LY",
		"\xfd\x96\x01": "SUB (IY+&01)",
		"\xfd\x97": "SUB A",
		"\xfd\x98": "SBC A,B",
		"\xfd\x99": "SBC A,C",
		"\xfd\x9a": "SBC A,D",
		"\xfd\x9b": "SBC A,E",
		"\xfd\x9c": "SBC A,HY",
		"\xfd\x9d": "SBC A,LY",
		"\xfd\x9e\x01": "SBC A,(IY+&01)",
		"\xfd\x9f": "SBC A,A",
		"\xfd\xa0": "AND B",
		"\xfd\xa1": "AND C",
		"\xfd\xa2": "AND D",
		"\xfd\xa3": "AND E",
		"\xfd\xa4": "AND HY",
		"\xfd\xa5": "AND LY",
		"\xfd\xa6\x01": "AND (IY+&01)",
		"\xfd\xa7": "AND A",
		"\xfd\xa8": "XOR B",
		"\xfd\xa9": "XOR C",
		"\xfd\xaa": "XOR D",
		"\xfd\xab": "XOR E",
		"\xfd\xac": "XOR HY",
		"\xfd\xad": "XOR LY",
		"\xfd\xae\x01": "XOR (IY+&01)",
		"\xfd\xaf": "XOR A",
		"\xfd\xb0": "OR B",
		"\xfd\xb1": "OR C",
		"\xfd\xb2": "OR D",
		"\xfd\xb3": "OR E",
		"\xfd\xb4": "OR HY",
		"\xfd\xb5": "OR LY",
		"\xfd\xb6\x01": "OR (IY+&01)",
		"\xfd\xb7": "OR A",
		"\xfd\xb8": "CP B",
		"\xfd\xb9": "CP C",
		"\xfd\xba": "CP D",
		"\xfd\xbb": "CP E",
		"\xfd\xbc": "CP HY",
		"\xfd\xbd": "CP LY",
		"\xfd\xbe\x01": "CP (IY+&01)",
		"\xfd\xbf": "CP A",
		"\xfd\xc0": "RET NZ",
		"\xfd\xc1": "POP BC",
		"\xfd\xc2\x01\x02": "JP NZ,&0201",
		"\xfd\xc3\x01\x02": "JP &0201",
		"\xfd\xc4\x01\x02": "CALL NZ,&0201",
		"\xfd\xc5": "PUSH BC",
		"\xfd\xc6\x01": "ADD A,&01",
		"\xfd\xc7": "RST &00",
		"\xfd\xc8": "RET Z",
		"\xfd\xc9": "RET",
		"\xfd\xca\x01\x02": "JP Z,&0201",
		"\xfd\xcb\x01\x02": "RLC (IY+&01) & LD D",
		"\xfd\xcc\x01\x02": "CALL Z,&0201",
		"\xfd\xcd\x01\x02": "CALL &0201",
		"\xfd\xce\x01": "ADC A,&01",
		"\xfd\xcf": "RST &08",
		"\xfd\xd0": "RET NC",
		"\xfd\xd1": "POP DE",
		"\xfd\xd2\x01\x02": "JP NC,&0201",
		"\xfd\xd3\x01": "OUT (&01),A",
		"\xfd\xd4\x01\x02": "CALL NC,&0201",
		"\xfd\xd5": "PUSH DE",
		"\xfd\xd6\x01": "SUB &01",
		"\xfd\xd7": "RST &10",
		"\xfd\xd8": "RET C",
		"\xfd\xd9": "EXX",
		"\xfd\xda\x01\x02": "JP C,&0201",
		"\xfd\xdb\x01": "IN A,(&01)",
		"\xfd\xdc\x01\x02": "CALL C,&0201",
		"\xfd\xdd": "[FD]-prefix",
		"\xfd\xde\x01": "SBC A,&01",
		"\xfd\xdf": "RST &18",
		"\xfd\xe0": "RET PO",
		"\xfd\xe1": "POP IY",
		"\xfd\xe2\x01\x02": "JP PO,&0201",
		"\xfd\xe3": "EX (SP),IY",
		"\xfd\xe4\x01\x02": "CALL PO,&0201",
		"\xfd\xe5": "PUSH IY",
		"\xfd\xe6\x01": "AND &01",
		"\xfd\xe7": "RST &20",
		"\xfd\xe8": "RET PE",
		"\xfd\xe9": "JP (IY)",
		"\xfd\xea\x01\x02": "JP PE,&0201",
		"\xfd\xeb": "EX DE,HL",
		"\xfd\xec\x01\x02": "CALL PE,&0201",
		"\xfd\xed": "[FD]-prefix",
		"\xfd\xee\x01": "XOR &01",
		"\xfd\xef": "RST &28",
		"\xfd\xf0": "RET P",
		"\xfd\xf1": "POP AF",
		"\xfd\xf2\x01\x02": "JP P,&0201",
		"\xfd\xf3": "DI",
		"\xfd\xf4\x01\x02": "CALL P,&0201",
		"\xfd\xf5": "PUSH AF",
		"\xfd\xf6\x01": "OR &01",
		"\xfd\xf7": "RST &30",
		"\xfd\xf8": "RET M",
		"\xfd\xf9": "LD SP,IY",
		"\xfd\xfa\x01\x02": "JP M,&0201",
		"\xfd\xfb": "EI",
		"\xfd\xfc\x01\x02": "CALL M,&0201",
		"\xfd\xfd": "[FD]-prefix",
		"\xfd\xfe\x01": "CP &01",
		"\xfd\xff": "RST &38"
	},
	prefixFDCB: {
		"\xfd\xcb\x03\x00": "RLC (IY+&03) & LD B",
		"\xfd\xcb\x03\x01": "RLC (IY+&03) & LD C",
		"\xfd\xcb\x03\x02": "RLC (IY+&03) & LD D",
		"\xfd\xcb\x03\x03": "RLC (IY+&03) & LD E",
		"\xfd\xcb\x03\x04": "RLC (IY+&03) & LD H",
		"\xfd\xcb\x03\x05": "RLC (IY+&03) & LD L",
		"\xfd\xcb\x03\x06": "RLC (IY+&03)",
		"\xfd\xcb\x03\x07": "RLC (IY+&03) & LD A",
		"\xfd\xcb\x03\x08": "RRC (IY+&03) & LD B",
		"\xfd\xcb\x03\x09": "RRC (IY+&03) & LD C",
		"\xfd\xcb\x03\x0a": "RRC (IY+&03) & LD D",
		"\xfd\xcb\x03\x0b": "RRC (IY+&03) & LD E",
		"\xfd\xcb\x03\x0c": "RRC (IY+&03) & LD H",
		"\xfd\xcb\x03\x0d": "RRC (IY+&03) & LD L",
		"\xfd\xcb\x03\x0e": "RRC (IY+&03)",
		"\xfd\xcb\x03\x0f": "RRC (IY+&03) & LD A",
		"\xfd\xcb\x03\x10": "RL (IY+&03) & LD B",
		"\xfd\xcb\x03\x11": "RL (IY+&03) & LD C",
		"\xfd\xcb\x03\x12": "RL (IY+&03) & LD D",
		"\xfd\xcb\x03\x13": "RL (IY+&03) & LD E",
		"\xfd\xcb\x03\x14": "RL (IY+&03) & LD H",
		"\xfd\xcb\x03\x15": "RL (IY+&03) & LD L",
		"\xfd\xcb\x03\x16": "RL (IY+&03)",
		"\xfd\xcb\x03\x17": "RL (IY+&03) & LD A",
		"\xfd\xcb\x03\x18": "RR (IY+&03) & LD B",
		"\xfd\xcb\x03\x19": "RR (IY+&03) & LD C",
		"\xfd\xcb\x03\x1a": "RR (IY+&03) & LD D",
		"\xfd\xcb\x03\x1b": "RR (IY+&03) & LD E",
		"\xfd\xcb\x03\x1c": "RR (IY+&03) & LD H",
		"\xfd\xcb\x03\x1d": "RR (IY+&03) & LD L",
		"\xfd\xcb\x03\x1e": "RR (IY+&03)",
		"\xfd\xcb\x03\x1f": "RR (IY+&03) & LD A",
		"\xfd\xcb\x03\x20": "SLA (IY+&03) & LD B",
		"\xfd\xcb\x03\x21": "SLA (IY+&03) & LD C",
		"\xfd\xcb\x03\x22": "SLA (IY+&03) & LD D",
		"\xfd\xcb\x03\x23": "SLA (IY+&03) & LD E",
		"\xfd\xcb\x03\x24": "SLA (IY+&03) & LD H",
		"\xfd\xcb\x03\x25": "SLA (IY+&03) & LD L",
		"\xfd\xcb\x03\x26": "SLA (IY+&03)",
		"\xfd\xcb\x03\x27": "SLA (IY+&03) & LD A",
		"\xfd\xcb\x03\x28": "SRA (IY+&03) & LD B",
		"\xfd\xcb\x03\x29": "SRA (IY+&03) & LD C",
		"\xfd\xcb\x03\x2a": "SRA (IY+&03) & LD D",
		"\xfd\xcb\x03\x2b": "SRA (IY+&03) & LD E",
		"\xfd\xcb\x03\x2c": "SRA (IY+&03) & LD H",
		"\xfd\xcb\x03\x2d": "SRA (IY+&03) & LD L",
		"\xfd\xcb\x03\x2e": "SRA (IY+&03)",
		"\xfd\xcb\x03\x2f": "SRA (IY+&03) & LD A",
		"\xfd\xcb\x03\x30": "SLS* (IY+&03) & LD B",
		"\xfd\xcb\x03\x31": "SLS* (IY+&03) & LD C",
		"\xfd\xcb\x03\x32": "SLS* (IY+&03) & LD D",
		"\xfd\xcb\x03\x33": "SLS* (IY+&03) & LD E",
		"\xfd\xcb\x03\x34": "SLS* (IY+&03) & LD H",
		"\xfd\xcb\x03\x35": "SLS* (IY+&03) & LD L",
		"\xfd\xcb\x03\x36": "SLS* (IY+&03)",
		"\xfd\xcb\x03\x37": "SLS* (IY+&03) & LD A",
		"\xfd\xcb\x03\x38": "SRL (IY+&03) & LD B",
		"\xfd\xcb\x03\x39": "SRL (IY+&03) & LD C",
		"\xfd\xcb\x03\x3a": "SRL (IY+&03) & LD D",
		"\xfd\xcb\x03\x3b": "SRL (IY+&03) & LD E",
		"\xfd\xcb\x03\x3c": "SRL (IY+&03) & LD H",
		"\xfd\xcb\x03\x3d": "SRL (IY+&03) & LD L",
		"\xfd\xcb\x03\x3e": "SRL (IY+&03)",
		"\xfd\xcb\x03\x3f": "SRL (IY+&03) & LD A",
		"\xfd\xcb\x03\x40": "BIT 0,(IY+&03)",
		"\xfd\xcb\x03\x41": "BIT 0,(IY+&03)",
		"\xfd\xcb\x03\x42": "BIT 0,(IY+&03)",
		"\xfd\xcb\x03\x43": "BIT 0,(IY+&03)",
		"\xfd\xcb\x03\x44": "BIT 0,(IY+&03)",
		"\xfd\xcb\x03\x45": "BIT 0,(IY+&03)",
		"\xfd\xcb\x03\x46": "BIT 0,(IY+&03)",
		"\xfd\xcb\x03\x47": "BIT 0,(IY+&03)",
		"\xfd\xcb\x03\x48": "BIT 1,(IY+&03)",
		"\xfd\xcb\x03\x49": "BIT 1,(IY+&03)",
		"\xfd\xcb\x03\x4a": "BIT 1,(IY+&03)",
		"\xfd\xcb\x03\x4b": "BIT 1,(IY+&03)",
		"\xfd\xcb\x03\x4c": "BIT 1,(IY+&03)",
		"\xfd\xcb\x03\x4d": "BIT 1,(IY+&03)",
		"\xfd\xcb\x03\x4e": "BIT 1,(IY+&03)",
		"\xfd\xcb\x03\x4f": "BIT 1,(IY+&03)",
		"\xfd\xcb\x03\x50": "BIT 2,(IY+&03)",
		"\xfd\xcb\x03\x51": "BIT 2,(IY+&03)",
		"\xfd\xcb\x03\x52": "BIT 2,(IY+&03)",
		"\xfd\xcb\x03\x53": "BIT 2,(IY+&03)",
		"\xfd\xcb\x03\x54": "BIT 2,(IY+&03)",
		"\xfd\xcb\x03\x55": "BIT 2,(IY+&03)",
		"\xfd\xcb\x03\x56": "BIT 2,(IY+&03)",
		"\xfd\xcb\x03\x57": "BIT 2,(IY+&03)",
		"\xfd\xcb\x03\x58": "BIT 3,(IY+&03)",
		"\xfd\xcb\x03\x59": "BIT 3,(IY+&03)",
		"\xfd\xcb\x03\x5a": "BIT 3,(IY+&03)",
		"\xfd\xcb\x03\x5b": "BIT 3,(IY+&03)",
		"\xfd\xcb\x03\x5c": "BIT 3,(IY+&03)",
		"\xfd\xcb\x03\x5d": "BIT 3,(IY+&03)",
		"\xfd\xcb\x03\x5e": "BIT 3,(IY+&03)",
		"\xfd\xcb\x03\x5f": "BIT 3,(IY+&03)",
		"\xfd\xcb\x03\x60": "BIT 4,(IY+&03)",
		"\xfd\xcb\x03\x61": "BIT 4,(IY+&03)",
		"\xfd\xcb\x03\x62": "BIT 4,(IY+&03)",
		"\xfd\xcb\x03\x63": "BIT 4,(IY+&03)",
		"\xfd\xcb\x03\x64": "BIT 4,(IY+&03)",
		"\xfd\xcb\x03\x65": "BIT 4,(IY+&03)",
		"\xfd\xcb\x03\x66": "BIT 4,(IY+&03)",
		"\xfd\xcb\x03\x67": "BIT 4,(IY+&03)",
		"\xfd\xcb\x03\x68": "BIT 5,(IY+&03)",
		"\xfd\xcb\x03\x69": "BIT 5,(IY+&03)",
		"\xfd\xcb\x03\x6a": "BIT 5,(IY+&03)",
		"\xfd\xcb\x03\x6b": "BIT 5,(IY+&03)",
		"\xfd\xcb\x03\x6c": "BIT 5,(IY+&03)",
		"\xfd\xcb\x03\x6d": "BIT 5,(IY+&03)",
		"\xfd\xcb\x03\x6e": "BIT 5,(IY+&03)",
		"\xfd\xcb\x03\x6f": "BIT 5,(IY+&03)",
		"\xfd\xcb\x03\x70": "BIT 6,(IY+&03)",
		"\xfd\xcb\x03\x71": "BIT 6,(IY+&03)",
		"\xfd\xcb\x03\x72": "BIT 6,(IY+&03)",
		"\xfd\xcb\x03\x73": "BIT 6,(IY+&03)",
		"\xfd\xcb\x03\x74": "BIT 6,(IY+&03)",
		"\xfd\xcb\x03\x75": "BIT 6,(IY+&03)",
		"\xfd\xcb\x03\x76": "BIT 6,(IY+&03)",
		"\xfd\xcb\x03\x77": "BIT 6,(IY+&03)",
		"\xfd\xcb\x03\x78": "BIT 7,(IY+&03)",
		"\xfd\xcb\x03\x79": "BIT 7,(IY+&03)",
		"\xfd\xcb\x03\x7a": "BIT 7,(IY+&03)",
		"\xfd\xcb\x03\x7b": "BIT 7,(IY+&03)",
		"\xfd\xcb\x03\x7c": "BIT 7,(IY+&03)",
		"\xfd\xcb\x03\x7d": "BIT 7,(IY+&03)",
		"\xfd\xcb\x03\x7e": "BIT 7,(IY+&03)",
		"\xfd\xcb\x03\x7f": "BIT 7,(IY+&03)",
		"\xfd\xcb\x03\x80": "RES 0,(IY+&03) & LD B",
		"\xfd\xcb\x03\x81": "RES 0,(IY+&03) & LD C",
		"\xfd\xcb\x03\x82": "RES 0,(IY+&03) & LD D",
		"\xfd\xcb\x03\x83": "RES 0,(IY+&03) & LD E",
		"\xfd\xcb\x03\x84": "RES 0,(IY+&03) & LD H",
		"\xfd\xcb\x03\x85": "RES 0,(IY+&03) & LD L",
		"\xfd\xcb\x03\x86": "RES 0,(IY+&03)",
		"\xfd\xcb\x03\x87": "RES 0,(IY+&03) & LD A",
		"\xfd\xcb\x03\x88": "RES 1,(IY+&03) & LD B",
		"\xfd\xcb\x03\x89": "RES 1,(IY+&03) & LD C",
		"\xfd\xcb\x03\x8a": "RES 1,(IY+&03) & LD D",
		"\xfd\xcb\x03\x8b": "RES 1,(IY+&03) & LD E",
		"\xfd\xcb\x03\x8c": "RES 1,(IY+&03) & LD H",
		"\xfd\xcb\x03\x8d": "RES 1,(IY+&03) & LD L",
		"\xfd\xcb\x03\x8e": "RES 1,(IY+&03)",
		"\xfd\xcb\x03\x8f": "RES 1,(IY+&03) & LD A",
		"\xfd\xcb\x03\x90": "RES 2,(IY+&03) & LD B",
		"\xfd\xcb\x03\x91": "RES 2,(IY+&03) & LD C",
		"\xfd\xcb\x03\x92": "RES 2,(IY+&03) & LD D",
		"\xfd\xcb\x03\x93": "RES 2,(IY+&03) & LD E",
		"\xfd\xcb\x03\x94": "RES 2,(IY+&03) & LD H",
		"\xfd\xcb\x03\x95": "RES 2,(IY+&03) & LD L",
		"\xfd\xcb\x03\x96": "RES 2,(IY+&03)",
		"\xfd\xcb\x03\x97": "RES 2,(IY+&03) & LD A",
		"\xfd\xcb\x03\x98": "RES 3,(IY+&03) & LD B",
		"\xfd\xcb\x03\x99": "RES 3,(IY+&03) & LD C",
		"\xfd\xcb\x03\x9a": "RES 3,(IY+&03) & LD D",
		"\xfd\xcb\x03\x9b": "RES 3,(IY+&03) & LD E",
		"\xfd\xcb\x03\x9c": "RES 3,(IY+&03) & LD H",
		"\xfd\xcb\x03\x9d": "RES 3,(IY+&03) & LD L",
		"\xfd\xcb\x03\x9e": "RES 3,(IY+&03)",
		"\xfd\xcb\x03\x9f": "RES 3,(IY+&03) & LD A",
		"\xfd\xcb\x03\xa0": "RES 4,(IY+&03) & LD B",
		"\xfd\xcb\x03\xa1": "RES 4,(IY+&03) & LD C",
		"\xfd\xcb\x03\xa2": "RES 4,(IY+&03) & LD D",
		"\xfd\xcb\x03\xa3": "RES 4,(IY+&03) & LD E",
		"\xfd\xcb\x03\xa4": "RES 4,(IY+&03) & LD H",
		"\xfd\xcb\x03\xa5": "RES 4,(IY+&03) & LD L",
		"\xfd\xcb\x03\xa6": "RES 4,(IY+&03)",
		"\xfd\xcb\x03\xa7": "RES 4,(IY+&03) & LD A",
		"\xfd\xcb\x03\xa8": "RES 5,(IY+&03) & LD B",
		"\xfd\xcb\x03\xa9": "RES 5,(IY+&03) & LD C",
		"\xfd\xcb\x03\xaa": "RES 5,(IY+&03) & LD D",
		"\xfd\xcb\x03\xab": "RES 5,(IY+&03) & LD E",
		"\xfd\xcb\x03\xac": "RES 5,(IY+&03) & LD H",
		"\xfd\xcb\x03\xad": "RES 5,(IY+&03) & LD L",
		"\xfd\xcb\x03\xae": "RES 5,(IY+&03)",
		"\xfd\xcb\x03\xaf": "RES 5,(IY+&03) & LD A",
		"\xfd\xcb\x03\xb0": "RES 6,(IY+&03) & LD B",
		"\xfd\xcb\x03\xb1": "RES 6,(IY+&03) & LD C",
		"\xfd\xcb\x03\xb2": "RES 6,(IY+&03) & LD D",
		"\xfd\xcb\x03\xb3": "RES 6,(IY+&03) & LD E",
		"\xfd\xcb\x03\xb4": "RES 6,(IY+&03) & LD H",
		"\xfd\xcb\x03\xb5": "RES 6,(IY+&03) & LD L",
		"\xfd\xcb\x03\xb6": "RES 6,(IY+&03)",
		"\xfd\xcb\x03\xb7": "RES 6,(IY+&03) & LD A",
		"\xfd\xcb\x03\xb8": "RES 7,(IY+&03) & LD B",
		"\xfd\xcb\x03\xb9": "RES 7,(IY+&03) & LD C",
		"\xfd\xcb\x03\xba": "RES 7,(IY+&03) & LD D",
		"\xfd\xcb\x03\xbb": "RES 7,(IY+&03) & LD E",
		"\xfd\xcb\x03\xbc": "RES 7,(IY+&03) & LD H",
		"\xfd\xcb\x03\xbd": "RES 7,(IY+&03) & LD L",
		"\xfd\xcb\x03\xbe": "RES 7,(IY+&03)",
		"\xfd\xcb\x03\xbf": "RES 7,(IY+&03) & LD A",
		"\xfd\xcb\x03\xc0": "SET 0,(IY+&03) & LD B",
		"\xfd\xcb\x03\xc1": "SET 0,(IY+&03) & LD C",
		"\xfd\xcb\x03\xc2": "SET 0,(IY+&03) & LD D",
		"\xfd\xcb\x03\xc3": "SET 0,(IY+&03) & LD E",
		"\xfd\xcb\x03\xc4": "SET 0,(IY+&03) & LD H",
		"\xfd\xcb\x03\xc5": "SET 0,(IY+&03) & LD L",
		"\xfd\xcb\x03\xc6": "SET 0,(IY+&03)",
		"\xfd\xcb\x03\xc7": "SET 0,(IY+&03) & LD A",
		"\xfd\xcb\x03\xc8": "SET 1,(IY+&03) & LD B",
		"\xfd\xcb\x03\xc9": "SET 1,(IY+&03) & LD C",
		"\xfd\xcb\x03\xca": "SET 1,(IY+&03) & LD D",
		"\xfd\xcb\x03\xcb": "SET 1,(IY+&03) & LD E",
		"\xfd\xcb\x03\xcc": "SET 1,(IY+&03) & LD H",
		"\xfd\xcb\x03\xcd": "SET 1,(IY+&03) & LD L",
		"\xfd\xcb\x03\xce": "SET 1,(IY+&03)",
		"\xfd\xcb\x03\xcf": "SET 1,(IY+&03) & LD A",
		"\xfd\xcb\x03\xd0": "SET 2,(IY+&03) & LD B",
		"\xfd\xcb\x03\xd1": "SET 2,(IY+&03) & LD C",
		"\xfd\xcb\x03\xd2": "SET 2,(IY+&03) & LD D",
		"\xfd\xcb\x03\xd3": "SET 2,(IY+&03) & LD E",
		"\xfd\xcb\x03\xd4": "SET 2,(IY+&03) & LD H",
		"\xfd\xcb\x03\xd5": "SET 2,(IY+&03) & LD L",
		"\xfd\xcb\x03\xd6": "SET 2,(IY+&03)",
		"\xfd\xcb\x03\xd7": "SET 2,(IY+&03) & LD A",
		"\xfd\xcb\x03\xd8": "SET 3,(IY+&03) & LD B",
		"\xfd\xcb\x03\xd9": "SET 3,(IY+&03) & LD C",
		"\xfd\xcb\x03\xda": "SET 3,(IY+&03) & LD D",
		"\xfd\xcb\x03\xdb": "SET 3,(IY+&03) & LD E",
		"\xfd\xcb\x03\xdc": "SET 3,(IY+&03) & LD H",
		"\xfd\xcb\x03\xdd": "SET 3,(IY+&03) & LD L",
		"\xfd\xcb\x03\xde": "SET 3,(IY+&03)",
		"\xfd\xcb\x03\xdf": "SET 3,(IY+&03) & LD A",
		"\xfd\xcb\x03\xe0": "SET 4,(IY+&03) & LD B",
		"\xfd\xcb\x03\xe1": "SET 4,(IY+&03) & LD C",
		"\xfd\xcb\x03\xe2": "SET 4,(IY+&03) & LD D",
		"\xfd\xcb\x03\xe3": "SET 4,(IY+&03) & LD E",
		"\xfd\xcb\x03\xe4": "SET 4,(IY+&03) & LD H",
		"\xfd\xcb\x03\xe5": "SET 4,(IY+&03) & LD L",
		"\xfd\xcb\x03\xe6": "SET 4,(IY+&03)",
		"\xfd\xcb\x03\xe7": "SET 4,(IY+&03) & LD A",
		"\xfd\xcb\x03\xe8": "SET 5,(IY+&03) & LD B",
		"\xfd\xcb\x03\xe9": "SET 5,(IY+&03) & LD C",
		"\xfd\xcb\x03\xea": "SET 5,(IY+&03) & LD D",
		"\xfd\xcb\x03\xeb": "SET 5,(IY+&03) & LD E",
		"\xfd\xcb\x03\xec": "SET 5,(IY+&03) & LD H",
		"\xfd\xcb\x03\xed": "SET 5,(IY+&03) & LD L",
		"\xfd\xcb\x03\xee": "SET 5,(IY+&03)",
		"\xfd\xcb\x03\xef": "SET 5,(IY+&03) & LD A",
		"\xfd\xcb\x03\xf0": "SET 6,(IY+&03) & LD B",
		"\xfd\xcb\x03\xf1": "SET 6,(IY+&03) & LD C",
		"\xfd\xcb\x03\xf2": "SET 6,(IY+&03) & LD D",
		"\xfd\xcb\x03\xf3": "SET 6,(IY+&03) & LD E",
		"\xfd\xcb\x03\xf4": "SET 6,(IY+&03) & LD H",
		"\xfd\xcb\x03\xf5": "SET 6,(IY+&03) & LD L",
		"\xfd\xcb\x03\xf6": "SET 6,(IY+&03)",
		"\xfd\xcb\x03\xf7": "SET 6,(IY+&03) & LD A",
		"\xfd\xcb\x03\xf8": "SET 7,(IY+&03) & LD B",
		"\xfd\xcb\x03\xf9": "SET 7,(IY+&03) & LD C",
		"\xfd\xcb\x03\xfa": "SET 7,(IY+&03) & LD D",
		"\xfd\xcb\x03\xfb": "SET 7,(IY+&03) & LD E",
		"\xfd\xcb\x03\xfc": "SET 7,(IY+&03) & LD H",
		"\xfd\xcb\x03\xfd": "SET 7,(IY+&03) & LD L",
		"\xfd\xcb\x03\xfe": "SET 7,(IY+&03)",
		"\xfd\xcb\x03\xff": "SET 7,(IY+&03) & LD A"
	},
	special: {
		"\x10\xfe": "DJNZ &0000",
		"\x10\xfd": "DJNZ &FFFF",
		"\x18\xfe": "JR &0000",
		"\x18\xfd": "JR &FFFF"
	}
};
/* eslint-enable quote-props */


type HooksWithZ80Disass = NestedHooks & {
	z80Disass: Z80Disass
};

function createZ80Disass() {
	return new Z80Disass({
		data: [] as unknown as Uint8Array,
		addr: 0,
		format: 4
	});
}

function createAllTests1(category: string, results: ResultType) {
	const z80Disass = createZ80Disass(),
		categoryMap: Record<string, number> = {
			prefixCB: 0xcb,
			prefixDD: 0xdd,
			prefixDDCB: 0xcbdd,
			prefixED: 0xed,
			prefixFD: 0xfd,
			prefixFDCB: 0xcbfd
		},
		prefix = categoryMap[category];

	for (let i = 0; i < 256; i += 1) {
		const data = [];

		if (prefix) {
			data.push(prefix & 0xff); // eslint-disable-line no-bitwise
			if (prefix > 255) {
				data.push(prefix >> 8); // eslint-disable-line no-bitwise
			}

			if (prefix === 0xcbdd || prefix === 0xcbfd) {
				data.push(3); // push a fixed index
			}
		}

		data.push(i);

		z80Disass.setOptions({
			data: data as unknown as Uint8Array,
			addr: 0
		});

		let result = z80Disass.disassLine();
		const options = z80Disass.getOptions();

		if (options.addr > data.length) { // some missing bytes?
			let j = 1;

			while (options.addr > data.length) {
				data.push(j);
				j += 1;
			}
			z80Disass.setOptions({
				addr: 0
			});
			result = z80Disass.disassLine(); // do it again
		}

		const key = data.map(function (value: number) {
			return String.fromCharCode(value);
		}).join("");

		results[category].push(TestHelper.hexInQuotes(key) + ": " + TestHelper.stringInQuotes(result));
	}
	return results;
}


QUnit.module("Z80Disass: Tests", function (hooks) {
	hooks.before(function () {
		const thisHooks = hooks as HooksWithZ80Disass;

		thisHooks.z80Disass = createZ80Disass();
	});

	function runSingleTest(z80Disass: Z80Disass, key: string) {
		const data = Utils.string2Uint8Array(key);

		z80Disass.setOptions({
			data: data,
			addr: 0
		});

		const result = z80Disass.disassLine(),
			options = z80Disass.getOptions();

		if (options.addr > data.length) {
			Utils.console.error("Data too short: key: " + TestHelper.hexInQuotes(key) + ", length: " + data.length + ", addr: " + options.addr);
		}

		return result;
	}

	function runTestsFor(category: string, tests: TestsType, assert?: Assert, results?: ResultType) {
		const thisHooks = hooks as HooksWithZ80Disass,
			z80Disass = thisHooks.z80Disass;

		if (results && TestHelper.config.test === "createAll") { // fast hack to do something else
			createAllTests1(category, results);

			if (assert) {
				assert.ok("See console: createAllTests1");
			}
			return;
		}

		for (const key in tests) {
			if (tests.hasOwnProperty(key)) {
				const expected = tests[key],
					result = runSingleTest(z80Disass, key);

				if (results) {
					results[category].push(TestHelper.hexInQuotes(key) + ": " + TestHelper.stringInQuotes(result));
				}

				if (assert) {
					assert.strictEqual(result, expected, TestHelper.hexInQuotes(key));
				}
			}
		}
	}

	TestHelper.generateAllTests(allTests, runTestsFor, hooks);
});

// end
